import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { RawSqlResultsToEntityTransformer } from "./transformer/RawSqlResultsToEntityTransformer";
import { PessimisticLockTransactionRequiredError } from "../error/PessimisticLockTransactionRequiredError";
import { NoVersionOrUpdateDateColumnError } from "../error/NoVersionOrUpdateDateColumnError";
import { OptimisticLockVersionMismatchError } from "../error/OptimisticLockVersionMismatchError";
import { OptimisticLockCanNotBeUsedError } from "../error/OptimisticLockCanNotBeUsedError";
import { JoinAttribute } from "./JoinAttribute";
import { RelationIdAttribute } from "./relation-id/RelationIdAttribute";
import { RelationCountAttribute } from "./relation-count/RelationCountAttribute";
import { RelationIdLoader } from "./relation-id/RelationIdLoader";
import { RelationIdMetadataToAttributeTransformer } from "./relation-id/RelationIdMetadataToAttributeTransformer";
import { RelationCountLoader } from "./relation-count/RelationCountLoader";
import { RelationCountMetadataToAttributeTransformer } from "./relation-count/RelationCountMetadataToAttributeTransformer";
import { QueryBuilder } from "./QueryBuilder";
import { LockNotSupportedOnGivenDriverError } from "../error/LockNotSupportedOnGivenDriverError";
import { OffsetWithoutLimitNotSupportedError } from "../error/OffsetWithoutLimitNotSupportedError";
import { ObjectUtils } from "../util/ObjectUtils";
import { DriverUtils } from "../driver/DriverUtils";
import { EntityNotFoundError } from "../error/EntityNotFoundError";
import { TypeORMError } from "../error";
import { FindOptionsUtils } from "../find-options/FindOptionsUtils";
import { ApplyValueTransformers } from "../util/ApplyValueTransformers";
import { OrmUtils } from "../util/OrmUtils";
import { EntityPropertyNotFoundError } from "../error/EntityPropertyNotFoundError";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * Allows to build complex sql queries in a fashion way and execute those queries.
 */
export var SelectQueryBuilder = /*#__PURE__*/function (_QueryBuilder) {
  _inherits(SelectQueryBuilder, _QueryBuilder);
  var _super = _createSuper(SelectQueryBuilder);
  function SelectQueryBuilder() {
    var _this;
    _classCallCheck(this, SelectQueryBuilder);
    _this = _super.apply(this, arguments);
    _this["@instanceof"] = Symbol.for("SelectQueryBuilder");
    _this.findOptions = {};
    _this.selects = [];
    _this.joins = [];
    _this.conditions = "";
    _this.orderBys = [];
    _this.relationMetadatas = [];
    return _this;
  }
  // -------------------------------------------------------------------------
  // Public Implemented Methods
  // -------------------------------------------------------------------------
  /**
   * Gets generated SQL query without parameters being replaced.
   */
  _createClass(SelectQueryBuilder, [{
    key: "getQuery",
    value: function getQuery() {
      var sql = this.createComment();
      sql += this.createCteExpression();
      sql += this.createSelectExpression();
      sql += this.createJoinExpression();
      sql += this.createWhereExpression();
      sql += this.createGroupByExpression();
      sql += this.createHavingExpression();
      sql += this.createOrderByExpression();
      sql += this.createLimitOffsetExpression();
      sql += this.createLockExpression();
      sql = sql.trim();
      if (this.expressionMap.subQuery) sql = "(" + sql + ")";
      return sql;
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
  }, {
    key: "setFindOptions",
    value: function setFindOptions(findOptions) {
      this.findOptions = findOptions;
      this.applyFindOptions();
      return this;
    }
    /**
     * Creates a subquery - query that can be used inside other queries.
     */
  }, {
    key: "subQuery",
    value: function subQuery() {
      var qb = this.createQueryBuilder();
      qb.expressionMap.subQuery = true;
      qb.parentQueryBuilder = this;
      return qb;
    }
    /**
     * Creates SELECT query and selects given data.
     * Replaces all previous selections if they exist.
     */
  }, {
    key: "select",
    value: function select(selection, selectionAliasName) {
      this.expressionMap.queryType = "select";
      if (Array.isArray(selection)) {
        this.expressionMap.selects = selection.map(function (selection) {
          return {
            selection: selection
          };
        });
      } else if (typeof selection === "function") {
        var subQueryBuilder = selection(this.subQuery());
        this.setParameters(subQueryBuilder.getParameters());
        this.expressionMap.selects.push({
          selection: subQueryBuilder.getQuery(),
          aliasName: selectionAliasName
        });
      } else if (selection) {
        this.expressionMap.selects = [{
          selection: selection,
          aliasName: selectionAliasName
        }];
      }
      return this;
    }
    /**
     * Adds new selection to the SELECT query.
     */
  }, {
    key: "addSelect",
    value: function addSelect(selection, selectionAliasName) {
      if (!selection) return this;
      if (Array.isArray(selection)) {
        this.expressionMap.selects = this.expressionMap.selects.concat(selection.map(function (selection) {
          return {
            selection: selection
          };
        }));
      } else if (typeof selection === "function") {
        var subQueryBuilder = selection(this.subQuery());
        this.setParameters(subQueryBuilder.getParameters());
        this.expressionMap.selects.push({
          selection: subQueryBuilder.getQuery(),
          aliasName: selectionAliasName
        });
      } else if (selection) {
        this.expressionMap.selects.push({
          selection: selection,
          aliasName: selectionAliasName
        });
      }
      return this;
    }
    /**
     * Set max execution time.
     * @param milliseconds
     */
  }, {
    key: "maxExecutionTime",
    value: function maxExecutionTime(milliseconds) {
      this.expressionMap.maxExecutionTime = milliseconds;
      return this;
    }
    /**
     * Sets whether the selection is DISTINCT.
     */
  }, {
    key: "distinct",
    value: function distinct() {
      var _distinct = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.expressionMap.selectDistinct = _distinct;
      return this;
    }
    /**
     * Sets the distinct on clause for Postgres.
     */
  }, {
    key: "distinctOn",
    value: function distinctOn(_distinctOn) {
      this.expressionMap.selectDistinctOn = _distinctOn;
      return this;
    }
  }, {
    key: "fromDummy",
    value: function fromDummy() {
      var _a;
      return this.from((_a = this.connection.driver.dummyTableName) !== null && _a !== void 0 ? _a : "(SELECT 1 AS dummy_column)", "dummy_table");
    }
    /**
     * Specifies FROM which entity's table select/update/delete will be executed.
     * Also sets a main string alias of the selection data.
     * Removes all previously set from-s.
     */
  }, {
    key: "from",
    value: function from(entityTarget, aliasName) {
      var mainAlias = this.createFromAlias(entityTarget, aliasName);
      this.expressionMap.setMainAlias(mainAlias);
      return this;
    }
    /**
     * Specifies FROM which entity's table select/update/delete will be executed.
     * Also sets a main string alias of the selection data.
     */
  }, {
    key: "addFrom",
    value: function addFrom(entityTarget, aliasName) {
      var alias = this.createFromAlias(entityTarget, aliasName);
      if (!this.expressionMap.mainAlias) this.expressionMap.setMainAlias(alias);
      return this;
    }
    /**
     * INNER JOINs (without selection).
     * You also need to specify an alias of the joined data.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "innerJoin",
    value: function innerJoin(entityOrProperty, alias, condition, parameters) {
      this.join("INNER", entityOrProperty, alias, condition, parameters);
      return this;
    }
    /**
     * LEFT JOINs (without selection).
     * You also need to specify an alias of the joined data.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "leftJoin",
    value: function leftJoin(entityOrProperty, alias, condition, parameters) {
      this.join("LEFT", entityOrProperty, alias, condition, parameters);
      return this;
    }
    /**
     * INNER JOINs and adds all selection properties to SELECT.
     * You also need to specify an alias of the joined data.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "innerJoinAndSelect",
    value: function innerJoinAndSelect(entityOrProperty, alias, condition, parameters) {
      this.addSelect(alias);
      this.innerJoin(entityOrProperty, alias, condition, parameters);
      return this;
    }
    /**
     * LEFT JOINs and adds all selection properties to SELECT.
     * You also need to specify an alias of the joined data.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "leftJoinAndSelect",
    value: function leftJoinAndSelect(entityOrProperty, alias, condition, parameters) {
      this.addSelect(alias);
      this.leftJoin(entityOrProperty, alias, condition, parameters);
      return this;
    }
    /**
     * INNER JOINs, SELECTs the data returned by a join and MAPs all that data to some entity's property.
     * This is extremely useful when you want to select some data and map it to some virtual property.
     * It will assume that there are multiple rows of selecting data, and mapped result will be an array.
     * You also need to specify an alias of the joined data.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "innerJoinAndMapMany",
    value: function innerJoinAndMapMany(mapToProperty, entityOrProperty, alias, condition, parameters) {
      this.addSelect(alias);
      this.join("INNER", entityOrProperty, alias, condition, parameters, mapToProperty, true);
      return this;
    }
    /**
     * INNER JOINs, SELECTs the data returned by a join and MAPs all that data to some entity's property.
     * This is extremely useful when you want to select some data and map it to some virtual property.
     * It will assume that there is a single row of selecting data, and mapped result will be a single selected value.
     * You also need to specify an alias of the joined data.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "innerJoinAndMapOne",
    value: function innerJoinAndMapOne(mapToProperty, entityOrProperty, alias, condition, parameters) {
      this.addSelect(alias);
      this.join("INNER", entityOrProperty, alias, condition, parameters, mapToProperty, false);
      return this;
    }
    /**
     * LEFT JOINs, SELECTs the data returned by a join and MAPs all that data to some entity's property.
     * This is extremely useful when you want to select some data and map it to some virtual property.
     * It will assume that there are multiple rows of selecting data, and mapped result will be an array.
     * You also need to specify an alias of the joined data.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "leftJoinAndMapMany",
    value: function leftJoinAndMapMany(mapToProperty, entityOrProperty, alias, condition, parameters) {
      this.addSelect(alias);
      this.join("LEFT", entityOrProperty, alias, condition, parameters, mapToProperty, true);
      return this;
    }
    /**
     * LEFT JOINs, SELECTs the data returned by a join and MAPs all that data to some entity's property.
     * This is extremely useful when you want to select some data and map it to some virtual property.
     * It will assume that there is a single row of selecting data, and mapped result will be a single selected value.
     * You also need to specify an alias of the joined data.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "leftJoinAndMapOne",
    value: function leftJoinAndMapOne(mapToProperty, entityOrProperty, alias, condition, parameters) {
      this.addSelect(alias);
      this.join("LEFT", entityOrProperty, alias, condition, parameters, mapToProperty, false);
      return this;
    }
    /**
     * LEFT JOINs relation id and maps it into some entity's property.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "loadRelationIdAndMap",
    value: function loadRelationIdAndMap(mapToProperty, relationName, aliasNameOrOptions, queryBuilderFactory) {
      var relationIdAttribute = new RelationIdAttribute(this.expressionMap);
      relationIdAttribute.mapToProperty = mapToProperty;
      relationIdAttribute.relationName = relationName;
      if (typeof aliasNameOrOptions === "string") relationIdAttribute.alias = aliasNameOrOptions;
      if (typeof aliasNameOrOptions === "object" && aliasNameOrOptions.disableMixedMap) relationIdAttribute.disableMixedMap = true;
      relationIdAttribute.queryBuilderFactory = queryBuilderFactory;
      this.expressionMap.relationIdAttributes.push(relationIdAttribute);
      if (relationIdAttribute.relation.junctionEntityMetadata) {
        this.expressionMap.createAlias({
          type: "other",
          name: relationIdAttribute.junctionAlias,
          metadata: relationIdAttribute.relation.junctionEntityMetadata
        });
      }
      return this;
    }
    /**
     * Counts number of entities of entity's relation and maps the value into some entity's property.
     * Optionally, you can add condition and parameters used in condition.
     */
  }, {
    key: "loadRelationCountAndMap",
    value: function loadRelationCountAndMap(mapToProperty, relationName, aliasName, queryBuilderFactory) {
      var relationCountAttribute = new RelationCountAttribute(this.expressionMap);
      relationCountAttribute.mapToProperty = mapToProperty;
      relationCountAttribute.relationName = relationName;
      relationCountAttribute.alias = aliasName;
      relationCountAttribute.queryBuilderFactory = queryBuilderFactory;
      this.expressionMap.relationCountAttributes.push(relationCountAttribute);
      this.expressionMap.createAlias({
        type: "other",
        name: relationCountAttribute.junctionAlias
      });
      if (relationCountAttribute.relation.junctionEntityMetadata) {
        this.expressionMap.createAlias({
          type: "other",
          name: relationCountAttribute.junctionAlias,
          metadata: relationCountAttribute.relation.junctionEntityMetadata
        });
      }
      return this;
    }
    /**
     * Loads all relation ids for all relations of the selected entity.
     * All relation ids will be mapped to relation property themself.
     * If array of strings is given then loads only relation ids of the given properties.
     */
  }, {
    key: "loadAllRelationIds",
    value: function loadAllRelationIds(options) {
      var _this2 = this;
      // todo: add skip relations
      this.expressionMap.mainAlias.metadata.relations.forEach(function (relation) {
        if (options !== undefined && options.relations !== undefined && options.relations.indexOf(relation.propertyPath) === -1) return;
        _this2.loadRelationIdAndMap(_this2.expressionMap.mainAlias.name + "." + relation.propertyPath, _this2.expressionMap.mainAlias.name + "." + relation.propertyPath, options);
      });
      return this;
    }
    /**
     * Sets WHERE condition in the query builder.
     * If you had previously WHERE expression defined,
     * calling this function will override previously set WHERE conditions.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "where",
    value: function where(_where, parameters) {
      this.expressionMap.wheres = []; // don't move this block below since computeWhereParameter can add where expressions
      var condition = this.getWhereCondition(_where);
      if (condition) this.expressionMap.wheres = [{
        type: "simple",
        condition: condition
      }];
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Adds new AND WHERE condition in the query builder.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "andWhere",
    value: function andWhere(where, parameters) {
      this.expressionMap.wheres.push({
        type: "and",
        condition: this.getWhereCondition(where)
      });
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Adds new OR WHERE condition in the query builder.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "orWhere",
    value: function orWhere(where, parameters) {
      this.expressionMap.wheres.push({
        type: "or",
        condition: this.getWhereCondition(where)
      });
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Sets a new where EXISTS clause
     */
  }, {
    key: "whereExists",
    value: function whereExists(subQuery) {
      return this.where.apply(this, _toConsumableArray(this.getExistsCondition(subQuery)));
    }
    /**
     * Adds a new AND where EXISTS clause
     */
  }, {
    key: "andWhereExists",
    value: function andWhereExists(subQuery) {
      return this.andWhere.apply(this, _toConsumableArray(this.getExistsCondition(subQuery)));
    }
    /**
     * Adds a new OR where EXISTS clause
     */
  }, {
    key: "orWhereExists",
    value: function orWhereExists(subQuery) {
      return this.orWhere.apply(this, _toConsumableArray(this.getExistsCondition(subQuery)));
    }
    /**
     * Adds new AND WHERE with conditions for the given ids.
     *
     * Ids are mixed.
     * It means if you have single primary key you can pass a simple id values, for example [1, 2, 3].
     * If you have multiple primary keys you need to pass object with property names and values specified,
     * for example [{ firstId: 1, secondId: 2 }, { firstId: 2, secondId: 3 }, ...]
     */
  }, {
    key: "whereInIds",
    value: function whereInIds(ids) {
      return this.where(this.getWhereInIdsCondition(ids));
    }
    /**
     * Adds new AND WHERE with conditions for the given ids.
     *
     * Ids are mixed.
     * It means if you have single primary key you can pass a simple id values, for example [1, 2, 3].
     * If you have multiple primary keys you need to pass object with property names and values specified,
     * for example [{ firstId: 1, secondId: 2 }, { firstId: 2, secondId: 3 }, ...]
     */
  }, {
    key: "andWhereInIds",
    value: function andWhereInIds(ids) {
      return this.andWhere(this.getWhereInIdsCondition(ids));
    }
    /**
     * Adds new OR WHERE with conditions for the given ids.
     *
     * Ids are mixed.
     * It means if you have single primary key you can pass a simple id values, for example [1, 2, 3].
     * If you have multiple primary keys you need to pass object with property names and values specified,
     * for example [{ firstId: 1, secondId: 2 }, { firstId: 2, secondId: 3 }, ...]
     */
  }, {
    key: "orWhereInIds",
    value: function orWhereInIds(ids) {
      return this.orWhere(this.getWhereInIdsCondition(ids));
    }
    /**
     * Sets HAVING condition in the query builder.
     * If you had previously HAVING expression defined,
     * calling this function will override previously set HAVING conditions.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "having",
    value: function having(_having, parameters) {
      this.expressionMap.havings.push({
        type: "simple",
        condition: _having
      });
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Adds new AND HAVING condition in the query builder.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "andHaving",
    value: function andHaving(having, parameters) {
      this.expressionMap.havings.push({
        type: "and",
        condition: having
      });
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Adds new OR HAVING condition in the query builder.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "orHaving",
    value: function orHaving(having, parameters) {
      this.expressionMap.havings.push({
        type: "or",
        condition: having
      });
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Sets GROUP BY condition in the query builder.
     * If you had previously GROUP BY expression defined,
     * calling this function will override previously set GROUP BY conditions.
     */
  }, {
    key: "groupBy",
    value: function groupBy(_groupBy) {
      if (_groupBy) {
        this.expressionMap.groupBys = [_groupBy];
      } else {
        this.expressionMap.groupBys = [];
      }
      return this;
    }
    /**
     * Adds GROUP BY condition in the query builder.
     */
  }, {
    key: "addGroupBy",
    value: function addGroupBy(groupBy) {
      this.expressionMap.groupBys.push(groupBy);
      return this;
    }
    /**
     * Sets ORDER BY condition in the query builder.
     * If you had previously ORDER BY expression defined,
     * calling this function will override previously set ORDER BY conditions.
     */
  }, {
    key: "orderBy",
    value: function orderBy(sort) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ASC";
      var nulls = arguments.length > 2 ? arguments[2] : undefined;
      if (order !== undefined && order !== "ASC" && order !== "DESC") throw new TypeORMError("SelectQueryBuilder.addOrderBy \"order\" can accept only \"ASC\" and \"DESC\" values.");
      if (nulls !== undefined && nulls !== "NULLS FIRST" && nulls !== "NULLS LAST") throw new TypeORMError("SelectQueryBuilder.addOrderBy \"nulls\" can accept only \"NULLS FIRST\" and \"NULLS LAST\" values.");
      if (sort) {
        if (typeof sort === "object") {
          this.expressionMap.orderBys = sort;
        } else {
          if (nulls) {
            this.expressionMap.orderBys = _defineProperty({}, sort, {
              order: order,
              nulls: nulls
            });
          } else {
            this.expressionMap.orderBys = _defineProperty({}, sort, order);
          }
        }
      } else {
        this.expressionMap.orderBys = {};
      }
      return this;
    }
    /**
     * Adds ORDER BY condition in the query builder.
     */
  }, {
    key: "addOrderBy",
    value: function addOrderBy(sort) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ASC";
      var nulls = arguments.length > 2 ? arguments[2] : undefined;
      if (order !== undefined && order !== "ASC" && order !== "DESC") throw new TypeORMError("SelectQueryBuilder.addOrderBy \"order\" can accept only \"ASC\" and \"DESC\" values.");
      if (nulls !== undefined && nulls !== "NULLS FIRST" && nulls !== "NULLS LAST") throw new TypeORMError("SelectQueryBuilder.addOrderBy \"nulls\" can accept only \"NULLS FIRST\" and \"NULLS LAST\" values.");
      if (nulls) {
        this.expressionMap.orderBys[sort] = {
          order: order,
          nulls: nulls
        };
      } else {
        this.expressionMap.orderBys[sort] = order;
      }
      return this;
    }
    /**
     * Set's LIMIT - maximum number of rows to be selected.
     * NOTE that it may not work as you expect if you are using joins.
     * If you want to implement pagination, and you are having join in your query,
     * then use instead take method instead.
     */
  }, {
    key: "limit",
    value: function limit(_limit) {
      this.expressionMap.limit = this.normalizeNumber(_limit);
      if (this.expressionMap.limit !== undefined && isNaN(this.expressionMap.limit)) throw new TypeORMError("Provided \"limit\" value is not a number. Please provide a numeric value.");
      return this;
    }
    /**
     * Set's OFFSET - selection offset.
     * NOTE that it may not work as you expect if you are using joins.
     * If you want to implement pagination, and you are having join in your query,
     * then use instead skip method instead.
     */
  }, {
    key: "offset",
    value: function offset(_offset) {
      this.expressionMap.offset = this.normalizeNumber(_offset);
      if (this.expressionMap.offset !== undefined && isNaN(this.expressionMap.offset)) throw new TypeORMError("Provided \"offset\" value is not a number. Please provide a numeric value.");
      return this;
    }
    /**
     * Sets maximal number of entities to take.
     */
  }, {
    key: "take",
    value: function take(_take) {
      this.expressionMap.take = this.normalizeNumber(_take);
      if (this.expressionMap.take !== undefined && isNaN(this.expressionMap.take)) throw new TypeORMError("Provided \"take\" value is not a number. Please provide a numeric value.");
      return this;
    }
    /**
     * Sets number of entities to skip.
     */
  }, {
    key: "skip",
    value: function skip(_skip) {
      this.expressionMap.skip = this.normalizeNumber(_skip);
      if (this.expressionMap.skip !== undefined && isNaN(this.expressionMap.skip)) throw new TypeORMError("Provided \"skip\" value is not a number. Please provide a numeric value.");
      return this;
    }
    /**
     * Set certain index to be used by the query.
     *
     * @param index Name of index to be used.
     */
  }, {
    key: "useIndex",
    value: function useIndex(index) {
      this.expressionMap.useIndex = index;
      return this;
    }
    /**
     * Sets locking mode.
     */
  }, {
    key: "setLock",
    value: function setLock(lockMode, lockVersion, lockTables) {
      this.expressionMap.lockMode = lockMode;
      this.expressionMap.lockVersion = lockVersion;
      this.expressionMap.lockTables = lockTables;
      return this;
    }
    /**
     * Sets lock handling by adding NO WAIT or SKIP LOCKED.
     */
  }, {
    key: "setOnLocked",
    value: function setOnLocked(onLocked) {
      this.expressionMap.onLocked = onLocked;
      return this;
    }
    /**
     * Disables the global condition of "non-deleted" for the entity with delete date columns.
     */
  }, {
    key: "withDeleted",
    value: function withDeleted() {
      this.expressionMap.withDeleted = true;
      return this;
    }
    /**
     * Gets first raw result returned by execution of generated query builder sql.
     */
  }, {
    key: "getRawOne",
    value: function () {
      var _getRawOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getRawMany();
            case 2:
              return _context.abrupt("return", _context.sent[0]);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getRawOne() {
        return _getRawOne.apply(this, arguments);
      }
      return getRawOne;
    }()
    /**
     * Gets all raw results returned by execution of generated query builder sql.
     */
  }, {
    key: "getRawMany",
    value: function () {
      var _getRawMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var queryRunner, transactionStartedByUs, results;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.expressionMap.lockMode === "optimistic")) {
                _context2.next = 2;
                break;
              }
              throw new OptimisticLockCanNotBeUsedError();
            case 2:
              this.expressionMap.queryEntity = false;
              queryRunner = this.obtainQueryRunner();
              transactionStartedByUs = false;
              _context2.prev = 5;
              if (!(this.expressionMap.useTransaction === true && queryRunner.isTransactionActive === false)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 9;
              return queryRunner.startTransaction();
            case 9:
              transactionStartedByUs = true;
            case 10:
              _context2.next = 12;
              return this.loadRawResults(queryRunner);
            case 12:
              results = _context2.sent;
              if (!transactionStartedByUs) {
                _context2.next = 16;
                break;
              }
              _context2.next = 16;
              return queryRunner.commitTransaction();
            case 16:
              return _context2.abrupt("return", results);
            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](5);
              if (!transactionStartedByUs) {
                _context2.next = 29;
                break;
              }
              _context2.prev = 22;
              _context2.next = 25;
              return queryRunner.rollbackTransaction();
            case 25:
              _context2.next = 29;
              break;
            case 27:
              _context2.prev = 27;
              _context2.t1 = _context2["catch"](22);
            case 29:
              throw _context2.t0;
            case 30:
              _context2.prev = 30;
              if (!(queryRunner !== this.queryRunner)) {
                _context2.next = 34;
                break;
              }
              _context2.next = 34;
              return queryRunner.release();
            case 34:
              return _context2.finish(30);
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[5, 19, 30, 35], [22, 27]]);
      }));
      function getRawMany() {
        return _getRawMany.apply(this, arguments);
      }
      return getRawMany;
    }()
    /**
     * Executes sql generated by query builder and returns object with raw results and entities created from them.
     */
  }, {
    key: "getRawAndEntities",
    value: function () {
      var _getRawAndEntities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var queryRunner, transactionStartedByUs, results;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              queryRunner = this.obtainQueryRunner();
              transactionStartedByUs = false;
              _context3.prev = 2;
              if (!(this.expressionMap.useTransaction === true && queryRunner.isTransactionActive === false)) {
                _context3.next = 7;
                break;
              }
              _context3.next = 6;
              return queryRunner.startTransaction();
            case 6:
              transactionStartedByUs = true;
            case 7:
              this.expressionMap.queryEntity = true;
              _context3.next = 10;
              return this.executeEntitiesAndRawResults(queryRunner);
            case 10:
              results = _context3.sent;
              if (!transactionStartedByUs) {
                _context3.next = 14;
                break;
              }
              _context3.next = 14;
              return queryRunner.commitTransaction();
            case 14:
              return _context3.abrupt("return", results);
            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](2);
              if (!transactionStartedByUs) {
                _context3.next = 27;
                break;
              }
              _context3.prev = 20;
              _context3.next = 23;
              return queryRunner.rollbackTransaction();
            case 23:
              _context3.next = 27;
              break;
            case 25:
              _context3.prev = 25;
              _context3.t1 = _context3["catch"](20);
            case 27:
              throw _context3.t0;
            case 28:
              _context3.prev = 28;
              if (!(queryRunner !== this.queryRunner)) {
                _context3.next = 32;
                break;
              }
              _context3.next = 32;
              return queryRunner.release();
            case 32:
              return _context3.finish(28);
            case 33:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 17, 28, 33], [20, 25]]);
      }));
      function getRawAndEntities() {
        return _getRawAndEntities.apply(this, arguments);
      }
      return getRawAndEntities;
    }()
    /**
     * Gets single entity returned by execution of generated query builder sql.
     */
  }, {
    key: "getOne",
    value: function () {
      var _getOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var results, result, metadata, actualVersion, _actualVersion;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.getRawAndEntities();
            case 2:
              results = _context4.sent;
              result = results.entities[0];
              if (!(result && this.expressionMap.lockMode === "optimistic" && this.expressionMap.lockVersion)) {
                _context4.next = 15;
                break;
              }
              metadata = this.expressionMap.mainAlias.metadata;
              if (!(this.expressionMap.lockVersion instanceof Date)) {
                _context4.next = 12;
                break;
              }
              actualVersion = metadata.updateDateColumn.getEntityValue(result); // what if columns arent set?
              if (!(actualVersion.getTime() !== this.expressionMap.lockVersion.getTime())) {
                _context4.next = 10;
                break;
              }
              throw new OptimisticLockVersionMismatchError(metadata.name, this.expressionMap.lockVersion, actualVersion);
            case 10:
              _context4.next = 15;
              break;
            case 12:
              _actualVersion = metadata.versionColumn.getEntityValue(result); // what if columns arent set?
              if (!(_actualVersion !== this.expressionMap.lockVersion)) {
                _context4.next = 15;
                break;
              }
              throw new OptimisticLockVersionMismatchError(metadata.name, this.expressionMap.lockVersion, _actualVersion);
            case 15:
              if (!(result === undefined)) {
                _context4.next = 17;
                break;
              }
              return _context4.abrupt("return", null);
            case 17:
              return _context4.abrupt("return", result);
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getOne() {
        return _getOne.apply(this, arguments);
      }
      return getOne;
    }()
    /**
     * Gets the first entity returned by execution of generated query builder sql or rejects the returned promise on error.
     */
  }, {
    key: "getOneOrFail",
    value: function () {
      var _getOneOrFail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var entity;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.getOne();
            case 2:
              entity = _context5.sent;
              if (entity) {
                _context5.next = 5;
                break;
              }
              throw new EntityNotFoundError(this.expressionMap.mainAlias.target, this);
            case 5:
              return _context5.abrupt("return", entity);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getOneOrFail() {
        return _getOneOrFail.apply(this, arguments);
      }
      return getOneOrFail;
    }()
    /**
     * Gets entities returned by execution of generated query builder sql.
     */
  }, {
    key: "getMany",
    value: function () {
      var _getMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var results;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(this.expressionMap.lockMode === "optimistic")) {
                _context6.next = 2;
                break;
              }
              throw new OptimisticLockCanNotBeUsedError();
            case 2:
              _context6.next = 4;
              return this.getRawAndEntities();
            case 4:
              results = _context6.sent;
              return _context6.abrupt("return", results.entities);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getMany() {
        return _getMany.apply(this, arguments);
      }
      return getMany;
    }()
    /**
     * Gets count - number of entities selected by sql generated by this query builder.
     * Count excludes all limitations set by setFirstResult and setMaxResults methods call.
     */
  }, {
    key: "getCount",
    value: function () {
      var _getCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var queryRunner, transactionStartedByUs, results;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(this.expressionMap.lockMode === "optimistic")) {
                _context7.next = 2;
                break;
              }
              throw new OptimisticLockCanNotBeUsedError();
            case 2:
              queryRunner = this.obtainQueryRunner();
              transactionStartedByUs = false;
              _context7.prev = 4;
              if (!(this.expressionMap.useTransaction === true && queryRunner.isTransactionActive === false)) {
                _context7.next = 9;
                break;
              }
              _context7.next = 8;
              return queryRunner.startTransaction();
            case 8:
              transactionStartedByUs = true;
            case 9:
              this.expressionMap.queryEntity = false;
              _context7.next = 12;
              return this.executeCountQuery(queryRunner);
            case 12:
              results = _context7.sent;
              if (!transactionStartedByUs) {
                _context7.next = 16;
                break;
              }
              _context7.next = 16;
              return queryRunner.commitTransaction();
            case 16:
              return _context7.abrupt("return", results);
            case 19:
              _context7.prev = 19;
              _context7.t0 = _context7["catch"](4);
              if (!transactionStartedByUs) {
                _context7.next = 29;
                break;
              }
              _context7.prev = 22;
              _context7.next = 25;
              return queryRunner.rollbackTransaction();
            case 25:
              _context7.next = 29;
              break;
            case 27:
              _context7.prev = 27;
              _context7.t1 = _context7["catch"](22);
            case 29:
              throw _context7.t0;
            case 30:
              _context7.prev = 30;
              if (!(queryRunner !== this.queryRunner)) {
                _context7.next = 34;
                break;
              }
              _context7.next = 34;
              return queryRunner.release();
            case 34:
              return _context7.finish(30);
            case 35:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[4, 19, 30, 35], [22, 27]]);
      }));
      function getCount() {
        return _getCount.apply(this, arguments);
      }
      return getCount;
    }()
    /**
     * Gets exists
     * Returns whether any rows exists matching current query.
     */
  }, {
    key: "getExists",
    value: function () {
      var _getExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var queryRunner, transactionStartedByUs, results;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(this.expressionMap.lockMode === "optimistic")) {
                _context8.next = 2;
                break;
              }
              throw new OptimisticLockCanNotBeUsedError();
            case 2:
              queryRunner = this.obtainQueryRunner();
              transactionStartedByUs = false;
              _context8.prev = 4;
              if (!(this.expressionMap.useTransaction === true && queryRunner.isTransactionActive === false)) {
                _context8.next = 9;
                break;
              }
              _context8.next = 8;
              return queryRunner.startTransaction();
            case 8:
              transactionStartedByUs = true;
            case 9:
              this.expressionMap.queryEntity = false;
              _context8.next = 12;
              return this.executeExistsQuery(queryRunner);
            case 12:
              results = _context8.sent;
              if (!transactionStartedByUs) {
                _context8.next = 16;
                break;
              }
              _context8.next = 16;
              return queryRunner.commitTransaction();
            case 16:
              return _context8.abrupt("return", results);
            case 19:
              _context8.prev = 19;
              _context8.t0 = _context8["catch"](4);
              if (!transactionStartedByUs) {
                _context8.next = 29;
                break;
              }
              _context8.prev = 22;
              _context8.next = 25;
              return queryRunner.rollbackTransaction();
            case 25:
              _context8.next = 29;
              break;
            case 27:
              _context8.prev = 27;
              _context8.t1 = _context8["catch"](22);
            case 29:
              throw _context8.t0;
            case 30:
              _context8.prev = 30;
              if (!(queryRunner !== this.queryRunner)) {
                _context8.next = 34;
                break;
              }
              _context8.next = 34;
              return queryRunner.release();
            case 34:
              return _context8.finish(30);
            case 35:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[4, 19, 30, 35], [22, 27]]);
      }));
      function getExists() {
        return _getExists.apply(this, arguments);
      }
      return getExists;
    }()
    /**
     * Executes built SQL query and returns entities and overall entities count (without limitation).
     * This method is useful to build pagination.
     */
  }, {
    key: "getManyAndCount",
    value: function () {
      var _getManyAndCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var queryRunner, transactionStartedByUs, entitiesAndRaw, cacheId, count, results;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(this.expressionMap.lockMode === "optimistic")) {
                _context9.next = 2;
                break;
              }
              throw new OptimisticLockCanNotBeUsedError();
            case 2:
              queryRunner = this.obtainQueryRunner();
              transactionStartedByUs = false;
              _context9.prev = 4;
              if (!(this.expressionMap.useTransaction === true && queryRunner.isTransactionActive === false)) {
                _context9.next = 9;
                break;
              }
              _context9.next = 8;
              return queryRunner.startTransaction();
            case 8:
              transactionStartedByUs = true;
            case 9:
              this.expressionMap.queryEntity = true;
              _context9.next = 12;
              return this.executeEntitiesAndRawResults(queryRunner);
            case 12:
              entitiesAndRaw = _context9.sent;
              this.expressionMap.queryEntity = false;
              cacheId = this.expressionMap.cacheId; // Creates a new cacheId for the count query, or it will retreive the above query results
              // and count will return 0.
              this.expressionMap.cacheId = cacheId ? "".concat(cacheId, "-count") : cacheId;
              _context9.next = 18;
              return this.executeCountQuery(queryRunner);
            case 18:
              count = _context9.sent;
              results = [entitiesAndRaw.entities, count]; // close transaction if we started it
              if (!transactionStartedByUs) {
                _context9.next = 23;
                break;
              }
              _context9.next = 23;
              return queryRunner.commitTransaction();
            case 23:
              return _context9.abrupt("return", results);
            case 26:
              _context9.prev = 26;
              _context9.t0 = _context9["catch"](4);
              if (!transactionStartedByUs) {
                _context9.next = 36;
                break;
              }
              _context9.prev = 29;
              _context9.next = 32;
              return queryRunner.rollbackTransaction();
            case 32:
              _context9.next = 36;
              break;
            case 34:
              _context9.prev = 34;
              _context9.t1 = _context9["catch"](29);
            case 36:
              throw _context9.t0;
            case 37:
              _context9.prev = 37;
              if (!(queryRunner !== this.queryRunner)) {
                _context9.next = 41;
                break;
              }
              _context9.next = 41;
              return queryRunner.release();
            case 41:
              return _context9.finish(37);
            case 42:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[4, 26, 37, 42], [29, 34]]);
      }));
      function getManyAndCount() {
        return _getManyAndCount.apply(this, arguments);
      }
      return getManyAndCount;
    }()
    /**
     * Executes built SQL query and returns raw data stream.
     */
  }, {
    key: "stream",
    value: function () {
      var _stream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this3 = this;
        var _this$getQueryAndPara, _this$getQueryAndPara2, sql, parameters, queryRunner, transactionStartedByUs, releaseFn, results;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.expressionMap.queryEntity = false;
              _this$getQueryAndPara = this.getQueryAndParameters(), _this$getQueryAndPara2 = _slicedToArray(_this$getQueryAndPara, 2), sql = _this$getQueryAndPara2[0], parameters = _this$getQueryAndPara2[1];
              queryRunner = this.obtainQueryRunner();
              transactionStartedByUs = false;
              _context10.prev = 4;
              if (!(this.expressionMap.useTransaction === true && queryRunner.isTransactionActive === false)) {
                _context10.next = 9;
                break;
              }
              _context10.next = 8;
              return queryRunner.startTransaction();
            case 8:
              transactionStartedByUs = true;
            case 9:
              releaseFn = function releaseFn() {
                if (queryRunner !== _this3.queryRunner)
                  // means we created our own query runner
                  return queryRunner.release();
                return;
              };
              results = queryRunner.stream(sql, parameters, releaseFn, releaseFn); // close transaction if we started it
              if (!transactionStartedByUs) {
                _context10.next = 14;
                break;
              }
              _context10.next = 14;
              return queryRunner.commitTransaction();
            case 14:
              return _context10.abrupt("return", results);
            case 17:
              _context10.prev = 17;
              _context10.t0 = _context10["catch"](4);
              if (!transactionStartedByUs) {
                _context10.next = 27;
                break;
              }
              _context10.prev = 20;
              _context10.next = 23;
              return queryRunner.rollbackTransaction();
            case 23:
              _context10.next = 27;
              break;
            case 25:
              _context10.prev = 25;
              _context10.t1 = _context10["catch"](20);
            case 27:
              throw _context10.t0;
            case 28:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[4, 17], [20, 25]]);
      }));
      function stream() {
        return _stream.apply(this, arguments);
      }
      return stream;
    }()
    /**
     * Enables or disables query result caching.
     */
  }, {
    key: "cache",
    value: function cache(enabledOrMillisecondsOrId, maybeMilliseconds) {
      if (typeof enabledOrMillisecondsOrId === "boolean") {
        this.expressionMap.cache = enabledOrMillisecondsOrId;
      } else if (typeof enabledOrMillisecondsOrId === "number") {
        this.expressionMap.cache = true;
        this.expressionMap.cacheDuration = enabledOrMillisecondsOrId;
      } else if (typeof enabledOrMillisecondsOrId === "string" || typeof enabledOrMillisecondsOrId === "number") {
        this.expressionMap.cache = true;
        this.expressionMap.cacheId = enabledOrMillisecondsOrId;
      }
      if (maybeMilliseconds) {
        this.expressionMap.cacheDuration = maybeMilliseconds;
      }
      return this;
    }
    /**
     * Sets extra options that can be used to configure how query builder works.
     */
  }, {
    key: "setOption",
    value: function setOption(option) {
      this.expressionMap.options.push(option);
      return this;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
  }, {
    key: "join",
    value: function join(direction, entityOrProperty, aliasName, condition, parameters, mapToProperty, isMappingMany) {
      this.setParameters(parameters || {});
      var joinAttribute = new JoinAttribute(this.connection, this.expressionMap);
      joinAttribute.direction = direction;
      joinAttribute.mapToProperty = mapToProperty;
      joinAttribute.isMappingMany = isMappingMany;
      joinAttribute.entityOrProperty = entityOrProperty; // relationName
      joinAttribute.condition = condition ? condition : undefined; // joinInverseSideCondition
      // joinAttribute.junctionAlias = joinAttribute.relation.isOwning ? parentAlias + "_" + destinationTableAlias : destinationTableAlias + "_" + parentAlias;
      this.expressionMap.joinAttributes.push(joinAttribute);
      if (joinAttribute.metadata) {
        if (joinAttribute.metadata.deleteDateColumn && !this.expressionMap.withDeleted) {
          var conditionDeleteColumn = "".concat(aliasName, ".").concat(joinAttribute.metadata.deleteDateColumn.propertyName, " IS NULL");
          joinAttribute.condition = joinAttribute.condition ? " ".concat(joinAttribute.condition, " AND ").concat(conditionDeleteColumn) : "".concat(conditionDeleteColumn);
        }
        // todo: find and set metadata right there?
        joinAttribute.alias = this.expressionMap.createAlias({
          type: "join",
          name: aliasName,
          metadata: joinAttribute.metadata
        });
        if (joinAttribute.relation && joinAttribute.relation.junctionEntityMetadata) {
          this.expressionMap.createAlias({
            type: "join",
            name: joinAttribute.junctionAlias,
            metadata: joinAttribute.relation.junctionEntityMetadata
          });
        }
      } else {
        var subQuery = "";
        if (typeof entityOrProperty === "function") {
          var subQueryBuilder = entityOrProperty(this.subQuery());
          this.setParameters(subQueryBuilder.getParameters());
          subQuery = subQueryBuilder.getQuery();
        } else {
          subQuery = entityOrProperty;
        }
        var isSubQuery = typeof entityOrProperty === "function" || entityOrProperty.substr(0, 1) === "(" && entityOrProperty.substr(-1) === ")";
        joinAttribute.alias = this.expressionMap.createAlias({
          type: "join",
          name: aliasName,
          tablePath: isSubQuery === false ? entityOrProperty : undefined,
          subQuery: isSubQuery === true ? subQuery : undefined
        });
      }
    }
    /**
     * Creates "SELECT FROM" part of SQL query.
     */
  }, {
    key: "createSelectExpression",
    value: function createSelectExpression() {
      var _this4 = this;
      if (!this.expressionMap.mainAlias) throw new TypeORMError("Cannot build query because main alias is not set (call qb#from method)");
      // todo throw exception if selects or from is missing
      var allSelects = [];
      var excludedSelects = [];
      if (this.expressionMap.mainAlias.hasMetadata) {
        var metadata = this.expressionMap.mainAlias.metadata;
        allSelects.push.apply(allSelects, _toConsumableArray(this.buildEscapedEntityColumnSelects(this.expressionMap.mainAlias.name, metadata)));
        excludedSelects.push.apply(excludedSelects, _toConsumableArray(this.findEntityColumnSelects(this.expressionMap.mainAlias.name, metadata)));
      }
      // add selects from joins
      this.expressionMap.joinAttributes.forEach(function (join) {
        if (join.metadata) {
          allSelects.push.apply(allSelects, _toConsumableArray(_this4.buildEscapedEntityColumnSelects(join.alias.name, join.metadata)));
          excludedSelects.push.apply(excludedSelects, _toConsumableArray(_this4.findEntityColumnSelects(join.alias.name, join.metadata)));
        } else {
          var hasMainAlias = _this4.expressionMap.selects.some(function (select) {
            return select.selection === join.alias.name;
          });
          if (hasMainAlias) {
            allSelects.push({
              selection: _this4.escape(join.alias.name) + ".*"
            });
            var excludedSelect = _this4.expressionMap.selects.find(function (select) {
              return select.selection === join.alias.name;
            });
            excludedSelects.push(excludedSelect);
          }
        }
      });
      // add all other selects
      this.expressionMap.selects.filter(function (select) {
        return excludedSelects.indexOf(select) === -1;
      }).forEach(function (select) {
        return allSelects.push({
          selection: _this4.replacePropertyNames(select.selection),
          aliasName: select.aliasName
        });
      });
      // if still selection is empty, then simply set it to all (*)
      if (allSelects.length === 0) allSelects.push({
        selection: "*"
      });
      // Use certain index
      var useIndex = "";
      if (this.expressionMap.useIndex) {
        if (DriverUtils.isMySQLFamily(this.connection.driver)) {
          useIndex = " USE INDEX (".concat(this.expressionMap.useIndex, ")");
        }
      }
      // create a selection query
      var froms = this.expressionMap.aliases.filter(function (alias) {
        return alias.type === "from" && (alias.tablePath || alias.subQuery);
      }).map(function (alias) {
        if (alias.subQuery) return alias.subQuery + " " + _this4.escape(alias.name);
        return _this4.getTableName(alias.tablePath) + " " + _this4.escape(alias.name);
      });
      var select = this.createSelectDistinctExpression();
      var selection = allSelects.map(function (select) {
        return select.selection + (select.aliasName ? " AS " + _this4.escape(select.aliasName) : "");
      }).join(", ");
      return select + selection + " FROM " + froms.join(", ") + this.createTableLockExpression() + useIndex;
    }
    /**
     * Creates select | select distinct part of SQL query.
     */
  }, {
    key: "createSelectDistinctExpression",
    value: function createSelectDistinctExpression() {
      var _this5 = this;
      var _this$expressionMap = this.expressionMap,
        selectDistinct = _this$expressionMap.selectDistinct,
        selectDistinctOn = _this$expressionMap.selectDistinctOn,
        maxExecutionTime = _this$expressionMap.maxExecutionTime;
      var driver = this.connection.driver;
      var select = "SELECT ";
      if (maxExecutionTime > 0) {
        if (DriverUtils.isMySQLFamily(driver)) {
          select += "/*+ MAX_EXECUTION_TIME(".concat(this.expressionMap.maxExecutionTime, ") */ ");
        }
      }
      if (DriverUtils.isPostgresFamily(driver) && selectDistinctOn.length > 0) {
        var selectDistinctOnMap = selectDistinctOn.map(function (on) {
          return _this5.replacePropertyNames(on);
        }).join(", ");
        select = "SELECT DISTINCT ON (".concat(selectDistinctOnMap, ") ");
      } else if (selectDistinct) {
        select = "SELECT DISTINCT ";
      }
      return select;
    }
    /**
     * Creates "JOIN" part of SQL query.
     */
  }, {
    key: "createJoinExpression",
    value: function createJoinExpression() {
      var _this6 = this;
      // examples:
      // select from owning side
      // qb.select("post")
      //     .leftJoinAndSelect("post.category", "category");
      // select from non-owning side
      // qb.select("category")
      //     .leftJoinAndSelect("category.post", "post");
      var joins = this.expressionMap.joinAttributes.map(function (joinAttr) {
        var relation = joinAttr.relation;
        var destinationTableName = joinAttr.tablePath;
        var destinationTableAlias = joinAttr.alias.name;
        var appendedCondition = joinAttr.condition ? " AND (" + joinAttr.condition + ")" : "";
        var parentAlias = joinAttr.parentAlias;
        // if join was build without relation (e.g. without "post.category") then it means that we have direct
        // table to join, without junction table involved. This means we simply join direct table.
        if (!parentAlias || !relation) {
          var destinationJoin = joinAttr.alias.subQuery ? joinAttr.alias.subQuery : _this6.getTableName(destinationTableName);
          return " " + joinAttr.direction + " JOIN " + destinationJoin + " " + _this6.escape(destinationTableAlias) + _this6.createTableLockExpression() + (joinAttr.condition ? " ON " + _this6.replacePropertyNames(joinAttr.condition) : "");
        }
        // if real entity relation is involved
        if (relation.isManyToOne || relation.isOneToOneOwner) {
          // JOIN `category` `category` ON `category`.`id` = `post`.`categoryId`
          var condition = relation.joinColumns.map(function (joinColumn) {
            return destinationTableAlias + "." + joinColumn.referencedColumn.propertyPath + "=" + parentAlias + "." + relation.propertyPath + "." + joinColumn.referencedColumn.propertyPath;
          }).join(" AND ");
          return " " + joinAttr.direction + " JOIN " + _this6.getTableName(destinationTableName) + " " + _this6.escape(destinationTableAlias) + _this6.createTableLockExpression() + " ON " + _this6.replacePropertyNames(condition + appendedCondition);
        } else if (relation.isOneToMany || relation.isOneToOneNotOwner) {
          // JOIN `post` `post` ON `post`.`categoryId` = `category`.`id`
          var _condition = relation.inverseRelation.joinColumns.map(function (joinColumn) {
            if (relation.inverseEntityMetadata.tableType === "entity-child" && relation.inverseEntityMetadata.discriminatorColumn) {
              appendedCondition += " AND " + destinationTableAlias + "." + relation.inverseEntityMetadata.discriminatorColumn.databaseName + "='" + relation.inverseEntityMetadata.discriminatorValue + "'";
            }
            return destinationTableAlias + "." + relation.inverseRelation.propertyPath + "." + joinColumn.referencedColumn.propertyPath + "=" + parentAlias + "." + joinColumn.referencedColumn.propertyPath;
          }).join(" AND ");
          return " " + joinAttr.direction + " JOIN " + _this6.getTableName(destinationTableName) + " " + _this6.escape(destinationTableAlias) + _this6.createTableLockExpression() + " ON " + _this6.replacePropertyNames(_condition + appendedCondition);
        } else {
          // means many-to-many
          var junctionTableName = relation.junctionEntityMetadata.tablePath;
          var junctionAlias = joinAttr.junctionAlias;
          var junctionCondition = "",
            destinationCondition = "";
          if (relation.isOwning) {
            junctionCondition = relation.joinColumns.map(function (joinColumn) {
              // `post_category`.`postId` = `post`.`id`
              return junctionAlias + "." + joinColumn.propertyPath + "=" + parentAlias + "." + joinColumn.referencedColumn.propertyPath;
            }).join(" AND ");
            destinationCondition = relation.inverseJoinColumns.map(function (joinColumn) {
              // `category`.`id` = `post_category`.`categoryId`
              return destinationTableAlias + "." + joinColumn.referencedColumn.propertyPath + "=" + junctionAlias + "." + joinColumn.propertyPath;
            }).join(" AND ");
          } else {
            junctionCondition = relation.inverseRelation.inverseJoinColumns.map(function (joinColumn) {
              // `post_category`.`categoryId` = `category`.`id`
              return junctionAlias + "." + joinColumn.propertyPath + "=" + parentAlias + "." + joinColumn.referencedColumn.propertyPath;
            }).join(" AND ");
            destinationCondition = relation.inverseRelation.joinColumns.map(function (joinColumn) {
              // `post`.`id` = `post_category`.`postId`
              return destinationTableAlias + "." + joinColumn.referencedColumn.propertyPath + "=" + junctionAlias + "." + joinColumn.propertyPath;
            }).join(" AND ");
          }
          return " " + joinAttr.direction + " JOIN " + _this6.getTableName(junctionTableName) + " " + _this6.escape(junctionAlias) + _this6.createTableLockExpression() + " ON " + _this6.replacePropertyNames(junctionCondition) + " " + joinAttr.direction + " JOIN " + _this6.getTableName(destinationTableName) + " " + _this6.escape(destinationTableAlias) + _this6.createTableLockExpression() + " ON " + _this6.replacePropertyNames(destinationCondition + appendedCondition);
        }
      });
      return joins.join(" ");
    }
    /**
     * Creates "GROUP BY" part of SQL query.
     */
  }, {
    key: "createGroupByExpression",
    value: function createGroupByExpression() {
      if (!this.expressionMap.groupBys || !this.expressionMap.groupBys.length) return "";
      return " GROUP BY " + this.replacePropertyNames(this.expressionMap.groupBys.join(", "));
    }
    /**
     * Creates "ORDER BY" part of SQL query.
     */
  }, {
    key: "createOrderByExpression",
    value: function createOrderByExpression() {
      var _this7 = this;
      var orderBys = this.expressionMap.allOrderBys;
      if (Object.keys(orderBys).length > 0) return " ORDER BY " + Object.keys(orderBys).map(function (columnName) {
        if (typeof orderBys[columnName] === "string") {
          return _this7.replacePropertyNames(columnName) + " " + orderBys[columnName];
        } else {
          return _this7.replacePropertyNames(columnName) + " " + orderBys[columnName].order + " " + orderBys[columnName].nulls;
        }
      }).join(", ");
      return "";
    }
    /**
     * Creates "LIMIT" and "OFFSET" parts of SQL query.
     */
  }, {
    key: "createLimitOffsetExpression",
    value: function createLimitOffsetExpression() {
      // in the case if nothing is joined in the query builder we don't need to make two requests to get paginated results
      // we can use regular limit / offset, that's why we add offset and limit construction here based on skip and take values
      var offset = this.expressionMap.offset,
        limit = this.expressionMap.limit;
      if (!offset && !limit && this.expressionMap.joinAttributes.length === 0) {
        offset = this.expressionMap.skip;
        limit = this.expressionMap.take;
      }
      if (this.connection.driver.options.type === "mssql") {
        // Due to a limitation in SQL Server's parser implementation it does not support using
        // OFFSET or FETCH NEXT without an ORDER BY clause being provided. In cases where the
        // user does not request one we insert a dummy ORDER BY that does nothing and should
        // have no effect on the query planner or on the order of the results returned.
        // https://dba.stackexchange.com/a/193799
        var prefix = "";
        if ((limit || offset) && Object.keys(this.expressionMap.allOrderBys).length <= 0) {
          prefix = " ORDER BY (SELECT NULL)";
        }
        if (limit && offset) return prefix + " OFFSET " + offset + " ROWS FETCH NEXT " + limit + " ROWS ONLY";
        if (limit) return prefix + " OFFSET 0 ROWS FETCH NEXT " + limit + " ROWS ONLY";
        if (offset) return prefix + " OFFSET " + offset + " ROWS";
      } else if (DriverUtils.isMySQLFamily(this.connection.driver) || this.connection.driver.options.type === "aurora-mysql" || this.connection.driver.options.type === "sap" || this.connection.driver.options.type === "spanner") {
        if (limit && offset) return " LIMIT " + limit + " OFFSET " + offset;
        if (limit) return " LIMIT " + limit;
        if (offset) throw new OffsetWithoutLimitNotSupportedError();
      } else if (DriverUtils.isSQLiteFamily(this.connection.driver)) {
        if (limit && offset) return " LIMIT " + limit + " OFFSET " + offset;
        if (limit) return " LIMIT " + limit;
        if (offset) return " LIMIT -1 OFFSET " + offset;
      } else if (this.connection.driver.options.type === "oracle") {
        if (limit && offset) return " OFFSET " + offset + " ROWS FETCH NEXT " + limit + " ROWS ONLY";
        if (limit) return " FETCH NEXT " + limit + " ROWS ONLY";
        if (offset) return " OFFSET " + offset + " ROWS";
      } else {
        if (limit && offset) return " LIMIT " + limit + " OFFSET " + offset;
        if (limit) return " LIMIT " + limit;
        if (offset) return " OFFSET " + offset;
      }
      return "";
    }
    /**
     * Creates "LOCK" part of SELECT Query after table Clause
     * ex.
     *  SELECT 1
     *  FROM USER U WITH (NOLOCK)
     *  JOIN ORDER O WITH (NOLOCK)
     *      ON U.ID=O.OrderID
     */
  }, {
    key: "createTableLockExpression",
    value: function createTableLockExpression() {
      if (this.connection.driver.options.type === "mssql") {
        switch (this.expressionMap.lockMode) {
          case "pessimistic_read":
            return " WITH (HOLDLOCK, ROWLOCK)";
          case "pessimistic_write":
            return " WITH (UPDLOCK, ROWLOCK)";
          case "dirty_read":
            return " WITH (NOLOCK)";
        }
      }
      return "";
    }
    /**
     * Creates "LOCK" part of SQL query.
     */
  }, {
    key: "createLockExpression",
    value: function createLockExpression() {
      var driver = this.connection.driver;
      var lockTablesClause = "";
      if (this.expressionMap.lockTables) {
        if (!(DriverUtils.isPostgresFamily(driver) || driver.options.type === "cockroachdb")) {
          throw new TypeORMError("Lock tables not supported in selected driver");
        }
        if (this.expressionMap.lockTables.length < 1) {
          throw new TypeORMError("lockTables cannot be an empty array");
        }
        lockTablesClause = " OF " + this.expressionMap.lockTables.join(", ");
      }
      var onLockExpression = "";
      if (this.expressionMap.onLocked === "nowait") {
        onLockExpression = " NOWAIT";
      } else if (this.expressionMap.onLocked === "skip_locked") {
        onLockExpression = " SKIP LOCKED";
      }
      switch (this.expressionMap.lockMode) {
        case "pessimistic_read":
          if (driver.options.type === "mysql" || driver.options.type === "aurora-mysql") {
            if (DriverUtils.isReleaseVersionOrGreater(driver, "8.0.0")) {
              return " FOR SHARE" + lockTablesClause + onLockExpression;
            } else {
              return " LOCK IN SHARE MODE";
            }
          } else if (driver.options.type === "mariadb") {
            return " LOCK IN SHARE MODE";
          } else if (DriverUtils.isPostgresFamily(driver)) {
            return " FOR SHARE" + lockTablesClause + onLockExpression;
          } else if (driver.options.type === "oracle") {
            return " FOR UPDATE";
          } else if (driver.options.type === "mssql") {
            return "";
          } else {
            throw new LockNotSupportedOnGivenDriverError();
          }
        case "pessimistic_write":
          if (DriverUtils.isMySQLFamily(driver) || driver.options.type === "aurora-mysql" || driver.options.type === "oracle") {
            return " FOR UPDATE" + onLockExpression;
          } else if (DriverUtils.isPostgresFamily(driver) || driver.options.type === "cockroachdb") {
            return " FOR UPDATE" + lockTablesClause + onLockExpression;
          } else if (driver.options.type === "mssql") {
            return "";
          } else {
            throw new LockNotSupportedOnGivenDriverError();
          }
        case "pessimistic_partial_write":
          if (DriverUtils.isPostgresFamily(driver)) {
            return " FOR UPDATE" + lockTablesClause + " SKIP LOCKED";
          } else if (DriverUtils.isMySQLFamily(driver)) {
            return " FOR UPDATE SKIP LOCKED";
          } else {
            throw new LockNotSupportedOnGivenDriverError();
          }
        case "pessimistic_write_or_fail":
          if (DriverUtils.isPostgresFamily(driver) || driver.options.type === "cockroachdb") {
            return " FOR UPDATE" + lockTablesClause + " NOWAIT";
          } else if (DriverUtils.isMySQLFamily(driver)) {
            return " FOR UPDATE NOWAIT";
          } else {
            throw new LockNotSupportedOnGivenDriverError();
          }
        case "for_no_key_update":
          if (DriverUtils.isPostgresFamily(driver) || driver.options.type === "cockroachdb") {
            return " FOR NO KEY UPDATE" + lockTablesClause + onLockExpression;
          } else {
            throw new LockNotSupportedOnGivenDriverError();
          }
        case "for_key_share":
          if (DriverUtils.isPostgresFamily(driver)) {
            return " FOR KEY SHARE" + lockTablesClause + onLockExpression;
          } else {
            throw new LockNotSupportedOnGivenDriverError();
          }
        default:
          return "";
      }
    }
    /**
     * Creates "HAVING" part of SQL query.
     */
  }, {
    key: "createHavingExpression",
    value: function createHavingExpression() {
      var _this8 = this;
      if (!this.expressionMap.havings || !this.expressionMap.havings.length) return "";
      var conditions = this.expressionMap.havings.map(function (having, index) {
        switch (having.type) {
          case "and":
            return (index > 0 ? "AND " : "") + _this8.replacePropertyNames(having.condition);
          case "or":
            return (index > 0 ? "OR " : "") + _this8.replacePropertyNames(having.condition);
          default:
            return _this8.replacePropertyNames(having.condition);
        }
      }).join(" ");
      if (!conditions.length) return "";
      return " HAVING " + conditions;
    }
  }, {
    key: "buildEscapedEntityColumnSelects",
    value: function buildEscapedEntityColumnSelects(aliasName, metadata) {
      var _this9 = this;
      var hasMainAlias = this.expressionMap.selects.some(function (select) {
        return select.selection === aliasName;
      });
      var columns = [];
      if (hasMainAlias) {
        columns.push.apply(columns, _toConsumableArray(metadata.columns.filter(function (column) {
          return column.isSelect === true;
        })));
      }
      columns.push.apply(columns, _toConsumableArray(metadata.columns.filter(function (column) {
        return _this9.expressionMap.selects.some(function (select) {
          return select.selection === aliasName + "." + column.propertyPath;
        });
      })));
      // if user used partial selection and did not select some primary columns which are required to be selected
      // we select those primary columns and mark them as "virtual". Later virtual column values will be removed from final entity
      // to make entity contain exactly what user selected
      if (columns.length === 0)
        // however not in the case when nothing (even partial) was selected from this target (for example joins without selection)
        return [];
      var nonSelectedPrimaryColumns = this.expressionMap.queryEntity ? metadata.primaryColumns.filter(function (primaryColumn) {
        return columns.indexOf(primaryColumn) === -1;
      }) : [];
      var allColumns = [].concat(columns, _toConsumableArray(nonSelectedPrimaryColumns));
      var finalSelects = [];
      var escapedAliasName = this.escape(aliasName);
      allColumns.forEach(function (column) {
        var selectionPath = escapedAliasName + "." + _this9.escape(column.databaseName);
        if (column.isVirtualProperty && column.query) {
          selectionPath = "(".concat(column.query(escapedAliasName), ")");
        }
        if (_this9.connection.driver.spatialTypes.indexOf(column.type) !== -1) {
          if (DriverUtils.isMySQLFamily(_this9.connection.driver) || _this9.connection.driver.options.type === "aurora-mysql") {
            var useLegacy = _this9.connection.driver.options.legacySpatialSupport;
            var asText = useLegacy ? "AsText" : "ST_AsText";
            selectionPath = "".concat(asText, "(").concat(selectionPath, ")");
          }
          if (DriverUtils.isPostgresFamily(_this9.connection.driver)) if (column.precision) {
            // cast to JSON to trigger parsing in the driver
            selectionPath = "ST_AsGeoJSON(".concat(selectionPath, ", ").concat(column.precision, ")::json");
          } else {
            selectionPath = "ST_AsGeoJSON(".concat(selectionPath, ")::json");
          }
          if (_this9.connection.driver.options.type === "mssql") selectionPath = "".concat(selectionPath, ".ToString()");
        }
        var selections = _this9.expressionMap.selects.filter(function (select) {
          return select.selection === aliasName + "." + column.propertyPath;
        });
        if (selections.length) {
          selections.forEach(function (selection) {
            finalSelects.push({
              selection: selectionPath,
              aliasName: selection.aliasName ? selection.aliasName : DriverUtils.buildAlias(_this9.connection.driver, aliasName, column.databaseName),
              // todo: need to keep in mind that custom selection.aliasName breaks hydrator. fix it later!
              virtual: selection.virtual
            });
          });
        } else {
          finalSelects.push({
            selection: selectionPath,
            aliasName: DriverUtils.buildAlias(_this9.connection.driver, aliasName, column.databaseName),
            // todo: need to keep in mind that custom selection.aliasName breaks hydrator. fix it later!
            virtual: hasMainAlias
          });
        }
      });
      return finalSelects;
    }
  }, {
    key: "findEntityColumnSelects",
    value: function findEntityColumnSelects(aliasName, metadata) {
      var mainSelect = this.expressionMap.selects.find(function (select) {
        return select.selection === aliasName;
      });
      if (mainSelect) return [mainSelect];
      return this.expressionMap.selects.filter(function (select) {
        return metadata.columns.some(function (column) {
          return select.selection === aliasName + "." + column.propertyPath;
        });
      });
    }
  }, {
    key: "computeCountExpression",
    value: function computeCountExpression() {
      var _this10 = this;
      var mainAlias = this.expressionMap.mainAlias.name; // todo: will this work with "fromTableName"?
      var metadata = this.expressionMap.mainAlias.metadata;
      var primaryColumns = metadata.primaryColumns;
      var distinctAlias = this.escape(mainAlias);
      // If we aren't doing anything that will create a join, we can use a simpler `COUNT` instead
      // so we prevent poor query patterns in the most likely cases
      if (this.expressionMap.joinAttributes.length === 0 && this.expressionMap.relationIdAttributes.length === 0 && this.expressionMap.relationCountAttributes.length === 0) {
        return "COUNT(1)";
      }
      // For everything else, we'll need to do some hackery to get the correct count values.
      if (this.connection.driver.options.type === "cockroachdb" || DriverUtils.isPostgresFamily(this.connection.driver)) {
        // Postgres and CockroachDB can pass multiple parameters to the `DISTINCT` function
        // https://www.postgresql.org/docs/9.5/sql-select.html#SQL-DISTINCT
        return "COUNT(DISTINCT(" + primaryColumns.map(function (c) {
          return "".concat(distinctAlias, ".").concat(_this10.escape(c.databaseName));
        }).join(", ") + "))";
      }
      if (DriverUtils.isMySQLFamily(this.connection.driver)) {
        // MySQL & MariaDB can pass multiple parameters to the `DISTINCT` language construct
        // https://mariadb.com/kb/en/count-distinct/
        return "COUNT(DISTINCT " + primaryColumns.map(function (c) {
          return "".concat(distinctAlias, ".").concat(_this10.escape(c.databaseName));
        }).join(", ") + ")";
      }
      if (this.connection.driver.options.type === "mssql") {
        // SQL Server has gotta be different from everyone else.  They don't support
        // distinct counting multiple columns & they don't have the same operator
        // characteristic for concatenating, so we gotta use the `CONCAT` function.
        // However, If it's exactly 1 column we can omit the `CONCAT` for better performance.
        var columnsExpression = primaryColumns.map(function (primaryColumn) {
          return "".concat(distinctAlias, ".").concat(_this10.escape(primaryColumn.databaseName));
        }).join(", '|;|', ");
        if (primaryColumns.length === 1) {
          return "COUNT(DISTINCT(".concat(columnsExpression, "))");
        }
        return "COUNT(DISTINCT(CONCAT(".concat(columnsExpression, ")))");
      }
      if (this.connection.driver.options.type === "spanner") {
        // spanner also has gotta be different from everyone else.
        // they do not support concatenation of different column types without casting them to string
        if (primaryColumns.length === 1) {
          return "COUNT(DISTINCT(".concat(distinctAlias, ".").concat(this.escape(primaryColumns[0].databaseName), "))");
        }
        var _columnsExpression = primaryColumns.map(function (primaryColumn) {
          return "CAST(".concat(distinctAlias, ".").concat(_this10.escape(primaryColumn.databaseName), " AS STRING)");
        }).join(", '|;|', ");
        return "COUNT(DISTINCT(CONCAT(".concat(_columnsExpression, ")))");
      }
      // If all else fails, fall back to a `COUNT` and `DISTINCT` across all the primary columns concatenated.
      // Per the SQL spec, this is the canonical string concatenation mechanism which is most
      // likely to work across servers implementing the SQL standard.
      // Please note, if there is only one primary column that the concatenation does not occur in this
      // query and the query is a standard `COUNT DISTINCT` in that case.
      return "COUNT(DISTINCT(" + primaryColumns.map(function (c) {
        return "".concat(distinctAlias, ".").concat(_this10.escape(c.databaseName));
      }).join(" || '|;|' || ") + "))";
    }
  }, {
    key: "executeCountQuery",
    value: function () {
      var _executeCountQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(queryRunner) {
        var countSql, results;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              countSql = this.computeCountExpression();
              _context11.next = 3;
              return this.clone().orderBy().groupBy().offset(undefined).limit(undefined).skip(undefined).take(undefined).select(countSql, "cnt").setOption("disable-global-order").loadRawResults(queryRunner);
            case 3:
              results = _context11.sent;
              if (!(!results || !results[0] || !results[0]["cnt"])) {
                _context11.next = 6;
                break;
              }
              return _context11.abrupt("return", 0);
            case 6:
              return _context11.abrupt("return", parseInt(results[0]["cnt"]));
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function executeCountQuery(_x) {
        return _executeCountQuery.apply(this, arguments);
      }
      return executeCountQuery;
    }()
  }, {
    key: "executeExistsQuery",
    value: function () {
      var _executeExistsQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(queryRunner) {
        var results;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.connection.createQueryBuilder().fromDummy().select("1", "row_exists").whereExists(this).limit(1).loadRawResults(queryRunner);
            case 2:
              results = _context12.sent;
              return _context12.abrupt("return", results.length > 0);
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function executeExistsQuery(_x2) {
        return _executeExistsQuery.apply(this, arguments);
      }
      return executeExistsQuery;
    }()
  }, {
    key: "applyFindOptions",
    value: function applyFindOptions() {
      var _this11 = this;
      // todo: convert relations: string[] to object map to simplify code
      // todo: same with selects
      if (this.expressionMap.mainAlias.metadata) {
        if (this.findOptions.relationLoadStrategy) {
          this.expressionMap.relationLoadStrategy = this.findOptions.relationLoadStrategy;
        }
        if (this.findOptions.comment) {
          this.comment(this.findOptions.comment);
        }
        if (this.findOptions.withDeleted) {
          this.withDeleted();
        }
        if (this.findOptions.select) {
          var select = Array.isArray(this.findOptions.select) ? OrmUtils.propertyPathsToTruthyObject(this.findOptions.select) : this.findOptions.select;
          this.buildSelect(select, this.expressionMap.mainAlias.metadata, this.expressionMap.mainAlias.name);
        }
        if (this.selects.length) {
          this.select(this.selects);
        }
        this.selects = [];
        if (this.findOptions.relations) {
          var relations = Array.isArray(this.findOptions.relations) ? OrmUtils.propertyPathsToTruthyObject(this.findOptions.relations) : this.findOptions.relations;
          this.buildRelations(relations, typeof this.findOptions.select === "object" ? this.findOptions.select : undefined, this.expressionMap.mainAlias.metadata, this.expressionMap.mainAlias.name);
          if (this.findOptions.loadEagerRelations !== false && this.expressionMap.relationLoadStrategy === "join") {
            this.buildEagerRelations(relations, typeof this.findOptions.select === "object" ? this.findOptions.select : undefined, this.expressionMap.mainAlias.metadata, this.expressionMap.mainAlias.name);
          }
        }
        if (this.selects.length) {
          this.addSelect(this.selects);
        }
        if (this.findOptions.where) {
          this.conditions = this.buildWhere(this.findOptions.where, this.expressionMap.mainAlias.metadata, this.expressionMap.mainAlias.name);
          if (this.conditions.length) this.andWhere(this.conditions.substr(0, 1) !== "(" ? "(" + this.conditions + ")" : this.conditions); // temporary and where and braces
        }

        if (this.findOptions.order) {
          this.buildOrder(this.findOptions.order, this.expressionMap.mainAlias.metadata, this.expressionMap.mainAlias.name);
        }
        // apply joins
        if (this.joins.length) {
          this.joins.forEach(function (join) {
            if (join.select && !join.selection) {
              // if (join.selection) {
              //
              // } else {
              if (join.type === "inner") {
                _this11.innerJoinAndSelect("".concat(join.parentAlias, ".").concat(join.relationMetadata.propertyPath), join.alias);
              } else {
                _this11.leftJoinAndSelect("".concat(join.parentAlias, ".").concat(join.relationMetadata.propertyPath), join.alias);
              }
              // }
            } else {
              if (join.type === "inner") {
                _this11.innerJoin("".concat(join.parentAlias, ".").concat(join.relationMetadata.propertyPath), join.alias);
              } else {
                _this11.leftJoin("".concat(join.parentAlias, ".").concat(join.relationMetadata.propertyPath), join.alias);
              }
            }
            // if (join.select) {
            //     if (this.findOptions.loadEagerRelations !== false) {
            //         FindOptionsUtils.joinEagerRelations(
            //             this,
            //             join.alias,
            //             join.relationMetadata.inverseEntityMetadata
            //         );
            //     }
            // }
          });
        }
        // if (this.conditions.length) {
        //     this.where(this.conditions.join(" AND "));
        // }
        // apply offset
        if (this.findOptions.skip !== undefined) {
          // if (this.findOptions.options && this.findOptions.options.pagination === false) {
          //     this.offset(this.findOptions.skip);
          // } else {
          this.skip(this.findOptions.skip);
          // }
        }
        // apply limit
        if (this.findOptions.take !== undefined) {
          // if (this.findOptions.options && this.findOptions.options.pagination === false) {
          //     this.limit(this.findOptions.take);
          // } else {
          this.take(this.findOptions.take);
          // }
        }
        // apply caching options
        if (typeof this.findOptions.cache === "number") {
          this.cache(this.findOptions.cache);
        } else if (typeof this.findOptions.cache === "boolean") {
          this.cache(this.findOptions.cache);
        } else if (typeof this.findOptions.cache === "object") {
          this.cache(this.findOptions.cache.id, this.findOptions.cache.milliseconds);
        }
        if (this.findOptions.join) {
          if (this.findOptions.join.leftJoin) Object.keys(this.findOptions.join.leftJoin).forEach(function (key) {
            _this11.leftJoin(_this11.findOptions.join.leftJoin[key], key);
          });
          if (this.findOptions.join.innerJoin) Object.keys(this.findOptions.join.innerJoin).forEach(function (key) {
            _this11.innerJoin(_this11.findOptions.join.innerJoin[key], key);
          });
          if (this.findOptions.join.leftJoinAndSelect) Object.keys(this.findOptions.join.leftJoinAndSelect).forEach(function (key) {
            _this11.leftJoinAndSelect(_this11.findOptions.join.leftJoinAndSelect[key], key);
          });
          if (this.findOptions.join.innerJoinAndSelect) Object.keys(this.findOptions.join.innerJoinAndSelect).forEach(function (key) {
            _this11.innerJoinAndSelect(_this11.findOptions.join.innerJoinAndSelect[key], key);
          });
        }
        if (this.findOptions.lock) {
          if (this.findOptions.lock.mode === "optimistic") {
            this.setLock(this.findOptions.lock.mode, this.findOptions.lock.version);
          } else if (this.findOptions.lock.mode === "pessimistic_read" || this.findOptions.lock.mode === "pessimistic_write" || this.findOptions.lock.mode === "dirty_read" || this.findOptions.lock.mode === "pessimistic_partial_write" || this.findOptions.lock.mode === "pessimistic_write_or_fail" || this.findOptions.lock.mode === "for_no_key_update" || this.findOptions.lock.mode === "for_key_share") {
            var tableNames = this.findOptions.lock.tables ? this.findOptions.lock.tables.map(function (table) {
              var tableAlias = _this11.expressionMap.aliases.find(function (alias) {
                return alias.metadata.tableNameWithoutPrefix === table;
              });
              if (!tableAlias) {
                throw new TypeORMError("\"".concat(table, "\" is not part of this query"));
              }
              return _this11.escape(tableAlias.name);
            }) : undefined;
            this.setLock(this.findOptions.lock.mode, undefined, tableNames);
            if (this.findOptions.lock.onLocked) {
              this.setOnLocked(this.findOptions.lock.onLocked);
            }
          }
        }
        if (this.findOptions.loadRelationIds === true) {
          this.loadAllRelationIds();
        } else if (typeof this.findOptions.loadRelationIds === "object") {
          this.loadAllRelationIds(this.findOptions.loadRelationIds);
        }
        if (this.findOptions.loadEagerRelations !== false) {
          FindOptionsUtils.joinEagerRelations(this, this.expressionMap.mainAlias.name, this.expressionMap.mainAlias.metadata);
        }
        if (this.findOptions.transaction === true) {
          this.expressionMap.useTransaction = true;
        }
        // if (this.orderBys.length) {
        //     this.orderBys.forEach(orderBy => {
        //         this.addOrderBy(orderBy.alias, orderBy.direction, orderBy.nulls);
        //     });
        // }
        // todo
        // if (this.options.options && this.options.options.eagerRelations) {
        //     this.queryBuilder
        // }
        // todo
        // if (this.findOptions.options && this.findOptions.listeners === false) {
        //     this.callListeners(false);
        // }
      }
    }
    /**
     * Executes sql generated by query builder and returns object with raw results and entities created from them.
     */
  }, {
    key: "executeEntitiesAndRawResults",
    value: function () {
      var _executeEntitiesAndRawResults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(queryRunner) {
        var _this12 = this;
        var metadata, relationIdLoader, relationCountLoader, relationIdMetadataTransformer, relationCountMetadataTransformer, rawResults, entities, _this$createOrderByCo, _this$createOrderByCo2, selects, orderBys, _metadata, mainAliasName, querySelects, condition, parameters, alias, ids, areAllNumbers, rawRelationIdResults, rawRelationCountResults, transformer;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (this.expressionMap.mainAlias) {
                _context14.next = 2;
                break;
              }
              throw new TypeORMError("Alias is not set. Use \"from\" method to set an alias.");
            case 2:
              if (!((this.expressionMap.lockMode === "pessimistic_read" || this.expressionMap.lockMode === "pessimistic_write" || this.expressionMap.lockMode === "pessimistic_partial_write" || this.expressionMap.lockMode === "pessimistic_write_or_fail" || this.expressionMap.lockMode === "for_no_key_update" || this.expressionMap.lockMode === "for_key_share") && !queryRunner.isTransactionActive)) {
                _context14.next = 4;
                break;
              }
              throw new PessimisticLockTransactionRequiredError();
            case 4:
              if (!(this.expressionMap.lockMode === "optimistic")) {
                _context14.next = 8;
                break;
              }
              metadata = this.expressionMap.mainAlias.metadata;
              if (!(!metadata.versionColumn && !metadata.updateDateColumn)) {
                _context14.next = 8;
                break;
              }
              throw new NoVersionOrUpdateDateColumnError(metadata.name);
            case 8:
              relationIdLoader = new RelationIdLoader(this.connection, queryRunner, this.expressionMap.relationIdAttributes);
              relationCountLoader = new RelationCountLoader(this.connection, queryRunner, this.expressionMap.relationCountAttributes);
              relationIdMetadataTransformer = new RelationIdMetadataToAttributeTransformer(this.expressionMap);
              relationIdMetadataTransformer.transform();
              relationCountMetadataTransformer = new RelationCountMetadataToAttributeTransformer(this.expressionMap);
              relationCountMetadataTransformer.transform();
              rawResults = [], entities = []; // for pagination enabled (e.g. skip and take) its much more complicated - its a special process
              // where we make two queries to find the data we need
              // first query find ids in skip and take range
              // and second query loads the actual data in given ids range
              if (!((this.expressionMap.skip || this.expressionMap.take) && this.expressionMap.joinAttributes.length > 0)) {
                _context14.next = 32;
                break;
              }
              // we are skipping order by here because its not working in subqueries anyway
              // to make order by working we need to apply it on a distinct query
              _this$createOrderByCo = this.createOrderByCombinedWithSelectExpression("distinctAlias"), _this$createOrderByCo2 = _slicedToArray(_this$createOrderByCo, 2), selects = _this$createOrderByCo2[0], orderBys = _this$createOrderByCo2[1];
              _metadata = this.expressionMap.mainAlias.metadata;
              mainAliasName = this.expressionMap.mainAlias.name;
              querySelects = _metadata.primaryColumns.map(function (primaryColumn) {
                var distinctAlias = _this12.escape("distinctAlias");
                var columnAlias = _this12.escape(DriverUtils.buildAlias(_this12.connection.driver, mainAliasName, primaryColumn.databaseName));
                if (!orderBys[columnAlias])
                  // make sure we aren't overriding user-defined order in inverse direction
                  orderBys[columnAlias] = "ASC";
                var alias = DriverUtils.buildAlias(_this12.connection.driver, "ids_" + mainAliasName, primaryColumn.databaseName);
                return "".concat(distinctAlias, ".").concat(columnAlias, " AS ").concat(_this12.escape(alias));
              });
              _context14.next = 22;
              return new SelectQueryBuilder(this.connection, queryRunner).select("DISTINCT ".concat(querySelects.join(", "))).addSelect(selects).from("(".concat(this.clone().orderBy().getQuery(), ")"), "distinctAlias").offset(this.expressionMap.skip).limit(this.expressionMap.take).orderBy(orderBys).cache(this.expressionMap.cache && this.expressionMap.cacheId ? "".concat(this.expressionMap.cacheId, "-pagination") : this.expressionMap.cache, this.expressionMap.cacheDuration).setParameters(this.getParameters()).setNativeParameters(this.expressionMap.nativeParameters).getRawMany();
            case 22:
              rawResults = _context14.sent;
              if (!(rawResults.length > 0)) {
                _context14.next = 30;
                break;
              }
              condition = "";
              parameters = {};
              if (_metadata.hasMultiplePrimaryKeys) {
                condition = rawResults.map(function (result, index) {
                  return _metadata.primaryColumns.map(function (primaryColumn) {
                    var paramKey = "orm_distinct_ids_".concat(index, "_").concat(primaryColumn.databaseName);
                    parameters[paramKey] = result["ids_".concat(mainAliasName, "_").concat(primaryColumn.databaseName)];
                    return "".concat(mainAliasName, ".").concat(primaryColumn.propertyPath, "=:").concat(paramKey);
                  }).join(" AND ");
                }).join(" OR ");
              } else {
                alias = DriverUtils.buildAlias(this.connection.driver, "ids_" + mainAliasName, _metadata.primaryColumns[0].databaseName);
                ids = rawResults.map(function (result) {
                  return result[alias];
                });
                areAllNumbers = ids.every(function (id) {
                  return typeof id === "number";
                });
                if (areAllNumbers) {
                  // fixes #190. if all numbers then its safe to perform query without parameter
                  condition = "".concat(mainAliasName, ".").concat(_metadata.primaryColumns[0].propertyPath, " IN (").concat(ids.join(", "), ")");
                } else {
                  parameters["orm_distinct_ids"] = ids;
                  condition = mainAliasName + "." + _metadata.primaryColumns[0].propertyPath + " IN (:...orm_distinct_ids)";
                }
              }
              _context14.next = 29;
              return this.clone().mergeExpressionMap({
                extraAppendedAndWhereCondition: condition
              }).setParameters(parameters).loadRawResults(queryRunner);
            case 29:
              rawResults = _context14.sent;
            case 30:
              _context14.next = 35;
              break;
            case 32:
              _context14.next = 34;
              return this.loadRawResults(queryRunner);
            case 34:
              rawResults = _context14.sent;
            case 35:
              if (!(rawResults.length > 0)) {
                _context14.next = 47;
                break;
              }
              _context14.next = 38;
              return relationIdLoader.load(rawResults);
            case 38:
              rawRelationIdResults = _context14.sent;
              _context14.next = 41;
              return relationCountLoader.load(rawResults);
            case 41:
              rawRelationCountResults = _context14.sent;
              transformer = new RawSqlResultsToEntityTransformer(this.expressionMap, this.connection.driver, rawRelationIdResults, rawRelationCountResults, this.queryRunner);
              entities = transformer.transform(rawResults, this.expressionMap.mainAlias);
              // broadcast all "after load" events
              if (!(this.expressionMap.callListeners === true && this.expressionMap.mainAlias.hasMetadata)) {
                _context14.next = 47;
                break;
              }
              _context14.next = 47;
              return queryRunner.broadcaster.broadcast("Load", this.expressionMap.mainAlias.metadata, entities);
            case 47:
              if (!(this.expressionMap.relationLoadStrategy === "query")) {
                _context14.next = 50;
                break;
              }
              _context14.next = 50;
              return Promise.all(this.relationMetadatas.map( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(relation) {
                  var relationTarget, relationAlias, select, relations, queryBuilder, relatedEntityGroups;
                  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        relationTarget = relation.inverseEntityMetadata.target;
                        relationAlias = relation.inverseEntityMetadata.targetName;
                        select = Array.isArray(_this12.findOptions.select) ? OrmUtils.propertyPathsToTruthyObject(_this12.findOptions.select) : _this12.findOptions.select;
                        relations = Array.isArray(_this12.findOptions.relations) ? OrmUtils.propertyPathsToTruthyObject(_this12.findOptions.relations) : _this12.findOptions.relations;
                        queryBuilder = _this12.createQueryBuilder().select(relationAlias).from(relationTarget, relationAlias).setFindOptions({
                          select: select ? OrmUtils.deepValue(select, relation.propertyPath) : undefined,
                          order: _this12.findOptions.order ? OrmUtils.deepValue(_this12.findOptions.order, relation.propertyPath) : undefined,
                          relations: relations ? OrmUtils.deepValue(relations, relation.propertyPath) : undefined,
                          withDeleted: _this12.findOptions.withDeleted,
                          relationLoadStrategy: _this12.findOptions.relationLoadStrategy
                        });
                        if (!(entities.length > 0)) {
                          _context13.next = 10;
                          break;
                        }
                        _context13.next = 8;
                        return _this12.connection.relationIdLoader.loadManyToManyRelationIdsAndGroup(relation, entities, undefined, queryBuilder);
                      case 8:
                        relatedEntityGroups = _context13.sent;
                        entities.forEach(function (entity) {
                          var relatedEntityGroup = relatedEntityGroups.find(function (group) {
                            return group.entity === entity;
                          });
                          if (relatedEntityGroup) {
                            var value = relatedEntityGroup.related === undefined ? null : relatedEntityGroup.related;
                            relation.setEntityValue(entity, value);
                          }
                        });
                      case 10:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee13);
                }));
                return function (_x4) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 50:
              return _context14.abrupt("return", {
                raw: rawResults,
                entities: entities
              });
            case 51:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function executeEntitiesAndRawResults(_x3) {
        return _executeEntitiesAndRawResults.apply(this, arguments);
      }
      return executeEntitiesAndRawResults;
    }()
  }, {
    key: "createOrderByCombinedWithSelectExpression",
    value: function createOrderByCombinedWithSelectExpression(parentAlias) {
      var _this13 = this;
      // if table has a default order then apply it
      var orderBys = this.expressionMap.allOrderBys;
      var selectString = Object.keys(orderBys).map(function (orderCriteria) {
        if (orderCriteria.indexOf(".") !== -1) {
          var criteriaParts = orderCriteria.split(".");
          var aliasName = criteriaParts[0];
          var propertyPath = criteriaParts.slice(1).join(".");
          var alias = _this13.expressionMap.findAliasByName(aliasName);
          var column = alias.metadata.findColumnWithPropertyPath(propertyPath);
          return _this13.escape(parentAlias) + "." + _this13.escape(DriverUtils.buildAlias(_this13.connection.driver, aliasName, column.databaseName));
        } else {
          if (_this13.expressionMap.selects.find(function (select) {
            return select.selection === orderCriteria || select.aliasName === orderCriteria;
          })) return _this13.escape(parentAlias) + "." + orderCriteria;
          return "";
        }
      }).join(", ");
      var orderByObject = {};
      Object.keys(orderBys).forEach(function (orderCriteria) {
        if (orderCriteria.indexOf(".") !== -1) {
          var criteriaParts = orderCriteria.split(".");
          var aliasName = criteriaParts[0];
          var propertyPath = criteriaParts.slice(1).join(".");
          var alias = _this13.expressionMap.findAliasByName(aliasName);
          var column = alias.metadata.findColumnWithPropertyPath(propertyPath);
          orderByObject[_this13.escape(parentAlias) + "." + _this13.escape(DriverUtils.buildAlias(_this13.connection.driver, aliasName, column.databaseName))] = orderBys[orderCriteria];
        } else {
          if (_this13.expressionMap.selects.find(function (select) {
            return select.selection === orderCriteria || select.aliasName === orderCriteria;
          })) {
            orderByObject[_this13.escape(parentAlias) + "." + orderCriteria] = orderBys[orderCriteria];
          } else {
            orderByObject[orderCriteria] = orderBys[orderCriteria];
          }
        }
      });
      return [selectString, orderByObject];
    }
    /**
     * Loads raw results from the database.
     */
  }, {
    key: "loadRawResults",
    value: function () {
      var _loadRawResults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(queryRunner) {
        var _this$getQueryAndPara3, _this$getQueryAndPara4, sql, parameters, queryId, cacheOptions, savedQueryResultCacheOptions, cacheError, results;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this$getQueryAndPara3 = this.getQueryAndParameters(), _this$getQueryAndPara4 = _slicedToArray(_this$getQueryAndPara3, 2), sql = _this$getQueryAndPara4[0], parameters = _this$getQueryAndPara4[1];
              queryId = sql + " -- PARAMETERS: " + JSON.stringify(parameters);
              cacheOptions = typeof this.connection.options.cache === "object" ? this.connection.options.cache : {};
              savedQueryResultCacheOptions = undefined;
              cacheError = false;
              if (!(this.connection.queryResultCache && (this.expressionMap.cache || cacheOptions.alwaysEnabled))) {
                _context15.next = 19;
                break;
              }
              _context15.prev = 6;
              _context15.next = 9;
              return this.connection.queryResultCache.getFromCache({
                identifier: this.expressionMap.cacheId,
                query: queryId,
                duration: this.expressionMap.cacheDuration || cacheOptions.duration || 1000
              }, queryRunner);
            case 9:
              savedQueryResultCacheOptions = _context15.sent;
              if (!(savedQueryResultCacheOptions && !this.connection.queryResultCache.isExpired(savedQueryResultCacheOptions))) {
                _context15.next = 12;
                break;
              }
              return _context15.abrupt("return", JSON.parse(savedQueryResultCacheOptions.result));
            case 12:
              _context15.next = 19;
              break;
            case 14:
              _context15.prev = 14;
              _context15.t0 = _context15["catch"](6);
              if (cacheOptions.ignoreErrors) {
                _context15.next = 18;
                break;
              }
              throw _context15.t0;
            case 18:
              cacheError = true;
            case 19:
              _context15.next = 21;
              return queryRunner.query(sql, parameters, true);
            case 21:
              results = _context15.sent;
              if (!(!cacheError && this.connection.queryResultCache && (this.expressionMap.cache || cacheOptions.alwaysEnabled))) {
                _context15.next = 32;
                break;
              }
              _context15.prev = 23;
              _context15.next = 26;
              return this.connection.queryResultCache.storeInCache({
                identifier: this.expressionMap.cacheId,
                query: queryId,
                time: new Date().getTime(),
                duration: this.expressionMap.cacheDuration || cacheOptions.duration || 1000,
                result: JSON.stringify(results.records)
              }, savedQueryResultCacheOptions, queryRunner);
            case 26:
              _context15.next = 32;
              break;
            case 28:
              _context15.prev = 28;
              _context15.t1 = _context15["catch"](23);
              if (cacheOptions.ignoreErrors) {
                _context15.next = 32;
                break;
              }
              throw _context15.t1;
            case 32:
              return _context15.abrupt("return", results.records);
            case 33:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[6, 14], [23, 28]]);
      }));
      function loadRawResults(_x5) {
        return _loadRawResults.apply(this, arguments);
      }
      return loadRawResults;
    }()
    /**
     * Merges into expression map given expression map properties.
     */
  }, {
    key: "mergeExpressionMap",
    value: function mergeExpressionMap(expressionMap) {
      ObjectUtils.assign(this.expressionMap, expressionMap);
      return this;
    }
    /**
     * Normalizes a give number - converts to int if possible.
     */
  }, {
    key: "normalizeNumber",
    value: function normalizeNumber(num) {
      if (typeof num === "number" || num === undefined || num === null) return num;
      return Number(num);
    }
    /**
     * Creates a query builder used to execute sql queries inside this query builder.
     */
  }, {
    key: "obtainQueryRunner",
    value: function obtainQueryRunner() {
      return this.queryRunner || this.connection.createQueryRunner("slave");
    }
  }, {
    key: "buildSelect",
    value: function buildSelect(select, metadata, alias, embedPrefix) {
      for (var key in select) {
        if (select[key] === undefined || select[key] === false) continue;
        var propertyPath = embedPrefix ? embedPrefix + "." + key : key;
        var column = metadata.findColumnWithPropertyPathStrict(propertyPath);
        var embed = metadata.findEmbeddedWithPropertyPath(propertyPath);
        var relation = metadata.findRelationWithPropertyPath(propertyPath);
        if (!embed && !column && !relation) throw new EntityPropertyNotFoundError(propertyPath, metadata);
        if (column) {
          this.selects.push(alias + "." + propertyPath);
          // this.addSelect(alias + "." + propertyPath);
        } else if (embed) {
          this.buildSelect(select[key], metadata, alias, propertyPath);
          // } else if (relation) {
          //     const joinAlias = alias + "_" + relation.propertyName;
          //     const existJoin = this.joins.find(join => join.alias === joinAlias);
          //     if (!existJoin) {
          //         this.joins.push({
          //             type: "left",
          //             select: false,
          //             alias: joinAlias,
          //             parentAlias: alias,
          //             relationMetadata: relation
          //         });
          //     }
          //     this.buildOrder(select[key] as FindOptionsOrder<any>, relation.inverseEntityMetadata, joinAlias);
        }
      }
    }
  }, {
    key: "buildRelations",
    value: function buildRelations(relations, selection, metadata, alias, embedPrefix) {
      var _this14 = this;
      if (!relations) return;
      Object.keys(relations).forEach(function (relationName) {
        var relationValue = relations[relationName];
        var propertyPath = embedPrefix ? embedPrefix + "." + relationName : relationName;
        var embed = metadata.findEmbeddedWithPropertyPath(propertyPath);
        var relation = metadata.findRelationWithPropertyPath(propertyPath);
        if (!embed && !relation) throw new EntityPropertyNotFoundError(propertyPath, metadata);
        if (embed) {
          _this14.buildRelations(relationValue, typeof selection === "object" ? OrmUtils.deepValue(selection, embed.propertyPath) : undefined, metadata, alias, propertyPath);
        } else if (relation) {
          var joinAlias = alias + "_" + propertyPath.replace(".", "_");
          joinAlias = DriverUtils.buildAlias(_this14.connection.driver, {
            joiner: "__"
          }, alias, joinAlias);
          if (relationValue === true || typeof relationValue === "object") {
            if (_this14.expressionMap.relationLoadStrategy === "query") {
              _this14.relationMetadatas.push(relation);
            } else {
              // join
              _this14.joins.push({
                type: "left",
                select: true,
                selection: selection && typeof selection[relationName] === "object" ? selection[relationName] : undefined,
                alias: joinAlias,
                parentAlias: alias,
                relationMetadata: relation
              });
              if (selection && typeof selection[relationName] === "object") {
                _this14.buildSelect(selection[relationName], relation.inverseEntityMetadata, joinAlias);
              }
            }
          }
          if (typeof relationValue === "object" && _this14.expressionMap.relationLoadStrategy === "join") {
            _this14.buildRelations(relationValue, typeof selection === "object" ? OrmUtils.deepValue(selection, relation.propertyPath) : undefined, relation.inverseEntityMetadata, joinAlias, undefined);
          }
        }
      });
    }
  }, {
    key: "buildEagerRelations",
    value: function buildEagerRelations(relations, selection, metadata, alias, embedPrefix) {
      var _this15 = this;
      if (!relations) return;
      Object.keys(relations).forEach(function (relationName) {
        var relationValue = relations[relationName];
        var propertyPath = embedPrefix ? embedPrefix + "." + relationName : relationName;
        var embed = metadata.findEmbeddedWithPropertyPath(propertyPath);
        var relation = metadata.findRelationWithPropertyPath(propertyPath);
        if (!embed && !relation) throw new EntityPropertyNotFoundError(propertyPath, metadata);
        if (embed) {
          _this15.buildEagerRelations(relationValue, typeof selection === "object" ? OrmUtils.deepValue(selection, embed.propertyPath) : undefined, metadata, alias, propertyPath);
        } else if (relation) {
          var joinAlias = alias + "_" + propertyPath.replace(".", "_");
          joinAlias = DriverUtils.buildAlias(_this15.connection.driver, {
            joiner: "__"
          }, alias, joinAlias);
          if (relationValue === true || typeof relationValue === "object") {
            relation.inverseEntityMetadata.eagerRelations.forEach(function (eagerRelation) {
              var eagerRelationJoinAlias = joinAlias + "_" + eagerRelation.propertyPath.replace(".", "_");
              eagerRelationJoinAlias = DriverUtils.buildAlias(_this15.connection.driver, {
                joiner: "__"
              }, joinAlias, eagerRelationJoinAlias);
              var existJoin = _this15.joins.find(function (join) {
                return join.alias === eagerRelationJoinAlias;
              });
              if (!existJoin) {
                _this15.joins.push({
                  type: "left",
                  select: true,
                  alias: eagerRelationJoinAlias,
                  parentAlias: joinAlias,
                  selection: undefined,
                  relationMetadata: eagerRelation
                });
              }
              if (selection && typeof selection[relationName] === "object") {
                _this15.buildSelect(selection[relationName], relation.inverseEntityMetadata, joinAlias);
              }
            });
          }
          if (typeof relationValue === "object") {
            _this15.buildEagerRelations(relationValue, typeof selection === "object" ? OrmUtils.deepValue(selection, relation.propertyPath) : undefined, relation.inverseEntityMetadata, joinAlias, undefined);
          }
        }
      });
    }
  }, {
    key: "buildOrder",
    value: function buildOrder(order, metadata, alias, embedPrefix) {
      var _this16 = this;
      var _loop = function _loop() {
        if (order[key] === undefined) return "continue";
        var propertyPath = embedPrefix ? embedPrefix + "." + key : key;
        var column = metadata.findColumnWithPropertyPathStrict(propertyPath);
        var embed = metadata.findEmbeddedWithPropertyPath(propertyPath);
        var relation = metadata.findRelationWithPropertyPath(propertyPath);
        if (!embed && !column && !relation) throw new EntityPropertyNotFoundError(propertyPath, metadata);
        if (column) {
          var direction = typeof order[key] === "object" ? order[key].direction : order[key];
          direction = direction === "DESC" || direction === "desc" || direction === -1 ? "DESC" : "ASC";
          var nulls = typeof order[key] === "object" ? order[key].nulls : undefined;
          nulls = (nulls === null || nulls === void 0 ? void 0 : nulls.toLowerCase()) === "first" ? "NULLS FIRST" : (nulls === null || nulls === void 0 ? void 0 : nulls.toLowerCase()) === "last" ? "NULLS LAST" : undefined;
          var aliasPath = "".concat(alias, ".").concat(propertyPath);
          if (column.isVirtualProperty && column.query) {
            var selection = _this16.expressionMap.selects.find(function (s) {
              return s.selection === aliasPath;
            });
            if (selection) {
              // this is not building correctly now???
              aliasPath = DriverUtils.buildAlias(_this16.connection.driver, alias, column.databaseName);
              selection.aliasName = aliasPath;
            } else {
              aliasPath = "(".concat(column.query(alias), ")");
            }
          }
          _this16.addOrderBy(aliasPath, direction, nulls);
          // this.orderBys.push({ alias: alias + "." + propertyPath, direction, nulls });
        } else if (embed) {
          _this16.buildOrder(order[key], metadata, alias, propertyPath);
        } else if (relation) {
          var joinAlias = alias + "_" + propertyPath.replace(".", "_");
          joinAlias = DriverUtils.buildAlias(_this16.connection.driver, {
            joiner: "__"
          }, alias, joinAlias);
          // console.log("joinAlias", joinAlias, joinAlias.length, this.connection.driver.maxAliasLength)
          // todo: use expressionMap.joinAttributes, and create a new one using
          //  const joinAttribute = new JoinAttribute(this.connection, this.expressionMap);
          var existJoin = _this16.joins.find(function (join) {
            return join.alias === joinAlias;
          });
          if (!existJoin) {
            _this16.joins.push({
              type: "left",
              select: false,
              alias: joinAlias,
              parentAlias: alias,
              selection: undefined,
              relationMetadata: relation
            });
          }
          _this16.buildOrder(order[key], relation.inverseEntityMetadata, joinAlias);
        }
      };
      for (var key in order) {
        var _ret = _loop();
        if (_ret === "continue") continue;
      }
    }
  }, {
    key: "buildWhere",
    value: function buildWhere(where, metadata, alias, embedPrefix) {
      var _this17 = this;
      var condition = "";
      // let parameterIndex = Object.keys(this.expressionMap.nativeParameters).length;
      if (Array.isArray(where)) {
        condition = "(" + where.map(function (whereItem) {
          return _this17.buildWhere(whereItem, metadata, alias, embedPrefix);
        }).filter(function (condition) {
          return !!condition;
        }).map(function (condition) {
          return "(" + condition + ")";
        }).join(" OR ") + ")";
      } else {
        var andConditions = [];
        var _loop2 = function _loop2(key) {
          if (where[key] === undefined || where[key] === null) return "continue";
          var propertyPath = embedPrefix ? embedPrefix + "." + key : key;
          var column = metadata.findColumnWithPropertyPathStrict(propertyPath);
          var embed = metadata.findEmbeddedWithPropertyPath(propertyPath);
          var relation = metadata.findRelationWithPropertyPath(propertyPath);
          if (!embed && !column && !relation) throw new EntityPropertyNotFoundError(propertyPath, metadata);
          if (column) {
            var aliasPath = "".concat(alias, ".").concat(propertyPath);
            if (column.isVirtualProperty && column.query) {
              aliasPath = "(".concat(column.query(alias), ")");
            }
            // const parameterName = alias + "_" + propertyPath.split(".").join("_") + "_" + parameterIndex;
            // todo: we need to handle other operators as well?
            var parameterValue = where[key];
            if (InstanceChecker.isEqualOperator(where[key])) {
              parameterValue = where[key].value;
            }
            if (column.transformer) {
              parameterValue = ApplyValueTransformers.transformTo(column.transformer, parameterValue);
            }
            // if (parameterValue === null) {
            //     andConditions.push(`${aliasPath} IS NULL`);
            //
            // } else if (parameterValue instanceof FindOperator) {
            //     // let parameters: any[] = [];
            //     // if (parameterValue.useParameter) {
            //     //     const realParameterValues: any[] = parameterValue.multipleParameters ? parameterValue.value : [parameterValue.value];
            //     //     realParameterValues.forEach((realParameterValue, realParameterValueIndex) => {
            //     //
            //     //         // don't create parameters for number to prevent max number of variables issues as much as possible
            //     //         if (typeof realParameterValue === "number") {
            //     //             parameters.push(realParameterValue);
            //     //
            //     //         } else {
            //     //             this.expressionMap.nativeParameters[parameterName + realParameterValueIndex] = realParameterValue;
            //     //             parameterIndex++;
            //     //             parameters.push(this.connection.driver.createParameter(parameterName + realParameterValueIndex, parameterIndex - 1));
            //     //         }
            //     //     });
            //     // }
            //     andConditions.push(
            //         this.createWhereConditionExpression(this.getWherePredicateCondition(aliasPath, parameterValue))
            //         // parameterValue.toSql(this.connection, aliasPath, parameters));
            //     )
            //
            // } else {
            //     this.expressionMap.nativeParameters[parameterName] = parameterValue;
            //     parameterIndex++;
            //     const parameter = this.connection.driver.createParameter(parameterName, parameterIndex - 1);
            //     andConditions.push(`${aliasPath} = ${parameter}`);
            // }
            andConditions.push(_this17.createWhereConditionExpression(_this17.getWherePredicateCondition(aliasPath, parameterValue)));
            // this.conditions.push(`${alias}.${propertyPath} = :${paramName}`);
            // this.expressionMap.parameters[paramName] = where[key]; // todo: handle functions and other edge cases
          } else if (embed) {
            var _condition2 = _this17.buildWhere(where[key], metadata, alias, propertyPath);
            if (_condition2) andConditions.push(_condition2);
          } else if (relation) {
            // if all properties of where are undefined we don't need to join anything
            // this can happen when user defines map with conditional queries inside
            if (typeof where[key] === "object") {
              var allAllUndefined = Object.keys(where[key]).every(function (k) {
                return where[key][k] === undefined;
              });
              if (allAllUndefined) {
                return "continue";
              }
            }
            if (InstanceChecker.isFindOperator(where[key])) {
              if (where[key].type === "moreThan" || where[key].type === "lessThan") {
                var sqlOperator = where[key].type === "moreThan" ? ">" : "<";
                // basically relation count functionality
                var qb = _this17.subQuery();
                if (relation.isManyToManyOwner) {
                  qb.select("COUNT(*)").from(relation.joinTableName, relation.joinTableName).where(relation.joinColumns.map(function (column) {
                    return "".concat(relation.joinTableName, ".").concat(column.propertyName, " = ").concat(alias, ".").concat(column.referencedColumn.propertyName);
                  }).join(" AND "));
                } else if (relation.isManyToManyNotOwner) {
                  qb.select("COUNT(*)").from(relation.inverseRelation.joinTableName, relation.inverseRelation.joinTableName).where(relation.inverseRelation.inverseJoinColumns.map(function (column) {
                    return "".concat(relation.inverseRelation.joinTableName, ".").concat(column.propertyName, " = ").concat(alias, ".").concat(column.referencedColumn.propertyName);
                  }).join(" AND "));
                } else if (relation.isOneToMany) {
                  qb.select("COUNT(*)").from(relation.inverseEntityMetadata.target, relation.inverseEntityMetadata.tableName).where(relation.inverseRelation.joinColumns.map(function (column) {
                    return "".concat(relation.inverseEntityMetadata.tableName, ".").concat(column.propertyName, " = ").concat(alias, ".").concat(column.referencedColumn.propertyName);
                  }).join(" AND "));
                } else {
                  throw new Error("This relation isn't supported by given find operator");
                }
                // this
                //     .addSelect(qb.getSql(), relation.propertyAliasName + "_cnt")
                //     .andWhere(this.escape(relation.propertyAliasName + "_cnt") + " " + sqlOperator + " " + parseInt(where[key].value));
                _this17.andWhere(qb.getSql() + " " + sqlOperator + " " + parseInt(where[key].value));
              } else {
                if (relation.isManyToOne || relation.isOneToOne && relation.isOneToOneOwner) {
                  var _aliasPath = "".concat(alias, ".").concat(propertyPath);
                  andConditions.push(_this17.createWhereConditionExpression(_this17.getWherePredicateCondition(_aliasPath, where[key])));
                } else {
                  throw new Error("This relation isn't supported by given find operator");
                }
              }
            } else {
              // const joinAlias = alias + "_" + relation.propertyName;
              var joinAlias = alias + "_" + relation.propertyPath.replace(".", "_");
              joinAlias = DriverUtils.buildAlias(_this17.connection.driver, {
                joiner: "__"
              }, alias, joinAlias);
              var existJoin = _this17.joins.find(function (join) {
                return join.alias === joinAlias;
              });
              if (!existJoin) {
                _this17.joins.push({
                  type: "left",
                  select: false,
                  selection: undefined,
                  alias: joinAlias,
                  parentAlias: alias,
                  relationMetadata: relation
                });
              }
              var _condition3 = _this17.buildWhere(where[key], relation.inverseEntityMetadata, joinAlias);
              if (_condition3) {
                andConditions.push(_condition3);
                // parameterIndex = Object.keys(this.expressionMap.nativeParameters).length;
              }
            }
          }
        };
        for (var key in where) {
          var _ret2 = _loop2(key);
          if (_ret2 === "continue") continue;
        }
        condition = andConditions.join(" AND ");
      }
      return condition;
    }
  }]);
  return SelectQueryBuilder;
}(QueryBuilder);